const it = {
	"401": {
		"oops": "Accidenti !",
		"noAuth": "Non hai il permesso di accedere a questa pagina",
		"goback": "Pagina precedente",
		"gohome": "Pagina iniziale"
	},
	"404": {
		"notFound": "Pagina non trovata"
	},
	"version": {
		"to_old": "Versione precedente",
		"to_new": "Versione aggiornata",
		"default_node": "Nodo predefinito",
		"default_theme": "Tema predefinito",
		"custom_theme": "Tema personalizzato"
	},
	"intro": {
		"sys_msg": "Messaggio di Sistema",
		"gaa_msg": "Promemoria con allarme",
		"new_guide": "Guida per principianti",
		"slider_quite": "Esci dall'ordine di avvio",
		"slider_pre": "Indietro",
		"slider_next": "Avanti",
		"slider_enter": "Accedi alla nuova versione",
		"step_project_1": "Gestione dei dispositivi del sistema nuovo",
		"step_project_2": "aggiunta",
		"step_project_3": "la funzione della gestione dei progetti",
		"step_project_4": "i dispositivi sono gestiti per progetti diversi. Gli utenti possono",
		"step_project_5": "creare, editare e eliminare",
		"step_mode_1": "Scegli lo stile preferito della lista dei dispositivi",
		"step_mode_2": "L'elenco dei dispositivi può essere presentato",
		"step_mode_3": "sotto forma di elenco o di schedina",
		"step_mode_4": "Puoi scegliere un modo di presentare dipende la tua situazione.",
		"step_device_1": "Trova rapidamente i dispositivi preferiti.",
		"step_device_2": "aggiunta",
		"step_device_3": "Segui",
		"step_device_4": "le funzioni dei dispositivi，",
		"step_device_5": "Quando si passa il mouse sul dispositivo di tuo interesse",
		"step_device_6": "Puoi fare clic su un preferito，",
		"step_device_7": "Dopo aver aggiunto a preferiti",
		"step_device_8": "Il dispositivo può trovarsi",
		"step_device_9": "una posizione come top del progetto",
		"step_device_10": "，per facilitare la ricerca del dispositivo preferito.",
		"step_operate_1": "La disposizione più chiara delle informazioni sul dispositivo",
		"step_operate_2": "Dopo aver scelto il dispositivo che vuoi sapere, è possibile sfogliare rapidamente i diagrammi del flusso energetico, le informazioni sul dispositivo, i grafici dei dati, l'analisi dei parametri, i dettagli dei dati e le informazioni di allarme del dispositivo."
	},
	"plantCode": {
		"codeApplication": "Richiesta per codice esperienza",
		"haveDevice": "Se hai già un dispositivo, puoi accedere per utilizzarlo dopo la registrazione.",
		"goRegister": "Vai alla registrazione",
		"useDemo": "Non hai ancora un codice invito? Il codice invito serve solo a dimostrare la funzione!",
		"applyNow": "Applica ora",
		"code_is_required": "Il codice esperienza non può essere vuoto",
		"pleaseCode": "Inserisci il codice di invito",
		"pleaseName": "Inserisci il tuo nome",
		"PleaseCompanyName": "Inserisci il nome della società",
		"PleaseCompanyAddress": "Inserisci l'indirizzo della società",
		"PleaseNumber": "Inserisci il tuo numero di cellulare di contatto",
		"PleaseEmail": "Inserisci il tuo indirizzo e-mail",
		"PleaseApplication": "Descrivi il motivo della tua richiesta",
		"reasonNotEmpty": "Il motivo della tua richiesta non può essere vuoto",
		"successfulApplication": "Richiesta riuscita. Si prega di prestare attezione a controllare la sua posta elettronica o i messaggi del cellulare e le risponderemo al più presto."
	},
	// 忘记账号
	"retrieveUser": {
		'forgetUser': 'Conto dimenticato',
		'illustrate': "Se dimentichi il tuo account, puoi ottenere informazioni sull'account inserendo il numero PN di qualsiasi dispositivo sotto il tuo account, aiutandoti a richiamare il tuo account!",
		'pn': 'Inserisci il PN di qualsiasi dispositivo sotto il tuo account',
		'comfig': 'Conferma',
		'Return_to_login': 'Torna al login',
		'accountInfo': "Informazioni sull'account",
		'user': 'Il tuo nome utente è',
		'phone': 'Il numero di telefono associato al tuo account è',
		'email': "L'email associata al tuo account è",
		'pleasePn': 'Inserisci il PN del dispositivo',
		'pnError': 'Il PN inserito non è corretto',
		'pnErrorMsg': 'Raccoglitore dati non trovato',
	},
	"login": {
		"login": "Accedi",
		"loginSuc": "Accesso effettuato con successo",
		"no_account_yet": "Non sei ancora iscritto?",
		"remember_pwd": "Memorizza password",
		"no_invitation": "Non hai ancora un codice esperienza? Ti preghiamo di contattarci",
		"linkman": "Eybond",
		"signup": "Iscriviti ora",
		"usr": "Nome utente",
		"pwd": "Password",
		"sample_station": "Dimostrazione",
		"invitation": "Codice esperienza",
		"invitationLogin": "Accedi col codice esperienza",
		"forgotPwd": "Hai dimenticato la password?",
		'forgotUser': 'Conto dimenticato',
		"usrformat": "Il formato dell'account (2<=lunghezza<=32)',",
		"pwdformat": "Il formato della Password (6<=lunghezza<=32)",
		"YHLogin": "Accesso utente",
		"Yzcode": "Inserisci il codice di verifica",
		"code": "Fai scorrere il cursore inferiore per completare il puzzle",
		"Swipe_right": "Scorri a destra",
		"scan_login": "Scansiona codice QR per accedere",
		"open": "Apri",
		"Scancode_login": "Scansiona codice QR per accedere",
		"scanning": "Scansione",
		"success": "Successo",
		"Pleaseconfirm_login": "Conferma l'accesso",
		"SmartESS": "SmartESS",
		"pv123": "PV123 ESS",
		'X_Tech': 'X-Tech',
		"app_download": "Scarica l'App",
		"scan_download": "Scarica l'App scansionando codice QR su cellulare",
		"YZcode_format": "Il formato del codice verifica è sbagliato. Inserisci i numeri",
		"no_validitycode": "Il codice di invito non è valido",
		"auto_login": "Login automatico",
	},
	"signup": {
		"login": "Accedi ora",
		"code": "Il codice di verifica a 6 cifre",
		"pwd": "6-32 caratteri (numeri, lettere e sottolineature), distinzione maiuscole/ minuscole",
		"confirm_password": "Conferma la password",
		"phone": "Cellulare",
		"phone_form": "Inserisci esattamente entro 32 caratteri per recuperare la password",
		"pn": "14 o 18 caratteri (solo numeri e lettere)",
		"usr": "2-32 carattere (solo cinese, lettera, numero e sottolineatura)",
		"email": "Posta elettronica",
		"email_form": "Inserisci esattamente entro 32 caratteri per recuperare la password",
		"existing_account": "Hai già un account?",
		"Register_account": "Registra account",
		"signup": "Iscriviti",
		"emailSignup": "Iscriviti per e-mail",
		"phoneSignup": "Registrazione del cellulare",
		"registered": "Iscriviti",
		"success": "Registrazione riuscita",
		"mobileformat": "Formato sbagliato del cellulare (6-32 cifre)",
		"mobileformat1": "Inserisci il giusto numero di cellulare",
		"emailformat": "Inserisci il giusto indirizzo di E-mail",
		"usrformat": "Errore dell'account, 2-32 caratteri (solo cinese, lettere, numeri e sottolineatura)",
		"pwdformat": "Errore della password, 6-32 caratteri (solo numeri, lettere e sottolineatura)",
		"pnformat": "Errore del PN, 14 o 18 caratteri (solo numeri e lettere)",
		"qiang": "Forte",
		"zhong": "Medio",
		"di": "Deobole",
		"qiangdu": "Forza password:",
		"Byte_1": "Inserito",
		"Byte_2": "Caratteri",
		"usr_pl": "Nome utente",
		"pwd_pl": "Password",
		"confirm_pl": "Conferma la password",
		"confirm_Pwdpl": "Conferma password",
		"email_pl": "Indirizzo e-mail",
		"mobile_pl": "Numero di cellulare",
		"code_pl": "Codice di verifica",
		"PN_pl": "Numero PN",
		"too_simple": "La password è troppo semplice, si prega di reimpostare",
		"country_pl": "Paese o regione",
	},
	"createPlant": {
		"imageLimit": "Supportate solo le immagini nel formato jpg o png. la dimensione massima non può superare 8M",
		"fileExceed": "Il file è troppo grande",
		"uploadSuccess": "Caricamento riuscito",
		"basic_settings": "Impostazione di base",
		"Standard_setting": "Impostazione standard",
		"System_settings": "Impostazione del sistema",
		"Solar_settings": "Impostazione dell'energia solare",
		"Grid_settings": "Impostazione della rete elettrica",
		"Battery_settings": "Impostazione della batteria",
		"Battery_settingsTT": "Impostazioni generali batteria",
		"Battery_settings1": "Gruppo Batterie 1",
		"Battery_settings2": "Gruppo Batterie 2",
		"Work_settings2": "Imposta lo stato operativo del sistema",
		"Machine_settings2": "Abilita la funzione di standby della macchina",
		"Clear_settings2": "Cancella guasto",
		"Control_settings": "Impostazione della macchina per lo stoccaggio di energia",
		"Load_setting": "Impostazione del carico",
		"other_settings": "Altre impostazioni",
		"Basic_setting": "Impostazione di base",
		"Advanced_setting": "Impostazione avanzata",
		"select_all": "Seleziona tutto",
		"pv": "PV",
		"gd": "Rete",
		"bt": "Batteria",
		"bc": "Carico",
		"sy": "Sistema",
		"eg": "Generatore",
		"hl": "CaricoDomestico"
	},
	"Upload": {
		"Upload": "Carica"
	},
	"menu": {
		"home": "Pagina iniziale",
		"datalogger": "Gestione del registratore di dati",
		"account": "Account",
		"device": "Dispositivo",
		"overview": "Panoramica",
		"alarm": "Di allarme",
		"setting": "Sistema",
		"personal": "Informazioni personali",
		"basic": "Informazioni di base",
		"password": "Modifica della password",
		"alarmSetting": "Impostazione dell'allarme",
		"email": "Impostazione di posta elettronica",
		"mobile": "Impostazione del cellulare",
		"recharge": "Impostazioni ricarica",
		"pay": "Ricarica del traffico",
		"record": "Storia di ricarica",
		"rate": "Impostazioni tariffarie",
		"customize": "Impostazione personalizzata",
		'firmware': 'Firmware di aggiornamento predefinito',
		'firmwarenew': 'Gestione del firmware',
		"adaptiveFirmware": "Firmware Adattivo",
		"intelligenceUpgrade": "Aggiornamento intelligente",
		"intelligenceUpgradeTitle": "Nessun pacchetto di aggiornamento disponibile, si prega di contattare il produttore",
		"intelligenceUpgradeTitle1": "Si prega di confermare se il dispositivo deve eseguire un aggiornamento intelligente?",
		"intelligenceUpgradeTitle2": "Nessun pacchetto di aggiornamento corrispondente trovato",
		"Total_user": "Totale degli utenti：",
		"myDevice": "Il mio dispositivo",
		'strategy': 'Strategia locale di aggiornamento',
		'cloudsUpgrade': 'Aggiornamento cloud',
		"functionalApplication": "Applicazione funzionale",
		'browseAccount': 'Gestione sottoconto',

		"log": "Registro del data logger",
		"actionLog": "Registro delle operazioni",
		"Manufacturer": "Gestione del produttore",
		"datalogger_list": "Elenco dei raccoglitori di dati",
		"manufacturer_account": "Conto del produttore",
		"manufacturer_code": "Codice del produttore",
		"protocol_binding": "Legamento del protocollo di acquisizione dati",
		"type_code": "Codice del tipo del dispositivo di acquisizione dati",
		"protocol_change": "Modifica del protocollo di acquisizione dati",
		"AIP_Interface": "Interfaccia API",
		"protocol_operation": "Strumento operativo protocollo",
		"recharge_management": "Gestione dei ricariche",
		"device_management": "gestione dei dispositivi",
		"KEY_List": "Elenco CHIAVE",
		"Protocol_instruction": "Gestione delle istruzioni di protocollo",
		"Raw_data": "Analisi dei dati grezzi",
		"Recharge_remedy": "Rimedio per la ricarica",
		"device_function": "Funzione di gestione delle apparecchiature",
		"Password_maintenance": "Manutenzione della password dell'elemento di controllo",
	},
	"header": {
		"plant_owner": "Proprietario della centrale elettrica",
		"personal_infor": "Informazioni personali",
		"change_password": "Modifica password",
		"bind_mobile": "Cellulare legato",
		"bind_email": "Posta elettronica legata",
		"language": "Lingue",
		"log_out": "Esci",
		"skin": "Cambia pelle",
		"shopping_mall": "Centro commerciale",
		'operating_manual': 'Manuale',
		"pleaseSelect": "Seleziona",
		"pleaseSelect1": "Seleziona ora",
		"pnAndAlias": "PN / Nome del registratore dati",
		"pnAndSN": "PN / SN"
	},
	"role": {
		"plantOwnerNew": "Utente normale",
		"plantOwner": "Proprietario della centrale elettrica",
		"manufacturer": "Account del produttore",
		"distributor": "Agente",
		"group": "Account dello Gruppo",
		"viewer": "Visitatore della centrale elettrica",
		"all": "Tutti"
	},
	"statistic": {
		"All": "Tutti",
		"regiontotal": "Totale delle zone",
		"deviceStatus": "Stato del dispositivo",
		"regionPercent": "Proporzioni dell'area",
		"userActivity": "Tasso di attività degli utenti",
		"dataUpdateTime": "Ora di aggiornamento dati",
		"normal": "Normale",
		"offline": "Disconnesso",
		"Allstate": "Tutto lo stato",
		"warning": "Attenzione",
		"fault": "Guasto",
		"standby": "In attesa",
		"totalDevice": "Tutti i dispositivi",
		"allDevice": "Il totale dei dispositivi",
		"totalRegion": "Tutte le zone",
		"other": "Altro",
		"allAccount": "Tutti gli utenti",
		"generalAccount": "Utente normale",
		"adminAccount": "Gestisci utenti",
		"active": "attivo",
		"inactive": "Inattivo",
		"pv": "Dati del pannello fotovoltaico",
		"gd": "Dati della rete elettrica",
		"sy": "Dati del dispositivo",
		"bt": "Dati della batteria",
		"bc": "Carica dati"
	},
	"account": {
		"title_pwd": "Inserisci la password corretta",
		"title_pwd1": "Inserisci una password a 6-32 bit",
		"title_pwd2": "Inserisci di nuovo la nuova password",
		"title_mobile": "Inserire un numero di telefono a 11 cifre",
		"title_edit": "Inserisci le informazioni che devono essere modificate",
		"title_info": "Inserisci l'indirizzo email corretto",
		"title_info1": "Inserire il numero di telefono corretto",
		"allAccount": "Tutti gli utenti",
		"userAccount": "Utente",
		"groupAccount": "Gruppo",
		"uselists": "Elenco per gestione degli utenti",
		"accountManage": "Gestione dell'account",
		"groupManage": "Gestione del gruppo",
		"activeStatus": "Livello di attività",
		"accountGroup": "Raggruppamento dell' utente",
		"createAccount": "Crea un account",
		"relatedOwner": "Proprietario associato",
		"relatedSuccess": "Associato con successo",
		"adminRelated": "Seleziona un amministratore",
		"role": "Tipo di utente",
		"role1": "Tipo di utente：",
		"selectUserType": "Seleziona tipo di utente",
		"generalAccount": "Account ordinario",
		"manageAccount": "Account dell'amministratore",
		"accountName": "Nome utente",
		"accountName1": "Nome utente",
		"accountName2": "Inserisca il nome utente per favore",
		"accountRole": "Ruolo",
		"nickname": "Nome utente",
		"nickname1": "Nome utente：",
		"password": "Password utente",
		"password1": "Password utente：",
		"newPwd": "Password nuova",
		"newPwd1": "Password nuova：",
		"confirmpassword": "Conferma password",
		"confirmpassword1": "Conferma password：",
		"createTime": "Tempo di creazione",
		"accountStatus": "Stato dell'account",
		"dataloggerNum": "Quantità di registratori dei dati",
		"deviceNum": "La quantità dei dispositivi",
		"projectNum": "Quantità dei progetti",
		"lastLogin": "Ultimo accesso",
		"editUser": "Modifica utente",
		"editAccount": "Modifica account",
		"group": "Gruppo",
		"group1": "Gruppo：",
		"groupto": "Gruppo a",
		"changeGroup": "Sposta gruppo in",
		"chooseGroup": "Seleziona un gruppo",
		"changeGroupSuc": "Gruppo spostato con successo",
		"defaultGroup": "Raggruppamento predefinito",
		"enable": "Abilita",
		"disable": "Disabilita",
		"confirmDisable": "Sei sicuro di disabilitare l'utente?",
		"afterDisable": "Dopo la disabilitazione, l'account non può accedere, visualizzare o modificare i contenuti pertinente dell'account",
		"disableSuc": "Disabilitato con successo",
		"confirmEnable": "Sei sicuro di abilitare questo utente?",
		"deleteUser": "Elimina l'account",
		"afterEnable": "Dopo l'abilitazione, l'account può riprendere l'accesso, visualizzare o modificare i contenuti pertinenti dell'account",
		"confirmDelete": "Sei sicuro di eliminare",
		"notRecovered": "Una volta eliminato, non può essere recuperato",
		"deleteSuc": "Rimosso con successo",
		"resetPwd": "Reimposta password",
		"allTypeUser": "Tutti i tipi degli utenti",
		"powerStationOwner": "Proprietario della centrale elettrica",
		"powerStationViewer": "Visitatore della centrale elettrica",
		"admin": "Amministratore",
		"riyueyuan_lineSonAdmin": "Sottoamministratore della linea di produzione",
		"riyueyuan_SonAdmin": "Sottoamministratore",
		"nodata": "Nessun dato",
		"reason": "Non mostrare il grafico potrebbe essere：",
		"reason1": "Nessun dato per il dispositivo",
		"reason2": "Il protocollo del dispositivo non dispone di campi di parametri  per la generazione, il consumo, l'acquisto, la vendita, il carico e lo scarico della quantità di carica elettrica",
		"reason3": "Il protocollo del dispositivo non dispone di campi di parametri per potenza di produzione di elettricità, potenza di carico, potenza della batteria e alimentazione della rete",
		"createSuc": "Account creato con successo",
		"resetPwdSuc": "Ripristino della password riuscito",
		"allGroup": "Tutti i gruppi",
		"unclassified": "Nessun gruppo",
		"cannotRedirect": "Questo account non è un account di stoccaggio di energia. Non può saltare",
		"newPwdEmpty": "La nuova password non può essere vuota, compilala!",
		"accountList": "Elenco dell'account",
		"mobile": "Cellulare",
		"mobile1": "Cellulare：",
		"email": "Posta elettronica",
		"email1": "Posta elettronica：",
		"modifiedsuccess": "Informazioni di utente modificate con sucesso!",
		"enablesuccess": "Abilitato con successo!",
		"disablesuccess": "Disabilitato con successo!",
		"groupsuccess": "Raggruppamento riuscito!",
		"pwdresetsuccess": "Password reimpostata con successo!",
		"Deletesuccessfully": "Account eliminato con successo!",
		"plantOwner": "Proprietario della centrale elettrica",
		"distributor": "Agente",
		"operate": "Operazione",
		"Edit": "Modifica",
		"Delete": "Cancella",
		"binding": "Legato",
		"ascription": "Attribuzione",
		"ascriptionSuccess": "Appartenenza con successo",
		"ascription_result": "Risultato dell'attribuzione",
		"cancel": "Annulla",
		"finish": "Fatto",
		"confirm": "Conferma",
		"submit": "Invia",
		"deletegroupsuccess": "E' rimosso dal gruppo con successo!",
		"deletegroup": "Rimuovi dal gruppo",
		"currentTotal": "Totale attuale",
		"projects": "Progetti",
		"searchPro": "Cerca progetto",
		"devices": "Dispositivi",
		"accounts": "Utenti",
		"placeholder": "Ricerca nome utente/numero di cellulare",
		"placeholder1": "Inserisci il tuo nome utente/numero di cellulare",
		"lastLoginTs": "Ultimo accesso",
		"enterHome": "Vai alla home page",
		"ownedDevices": "Dispositivi proprietari",
		"Distribution_collector": "Assegna collettori",
		"tooltipContent": "L'amministratore può assegnare tutti i registratori dati sull'ordine a un rivenditore subordinato tramite il numero d'ordine",
		"Distribution_method": "Metodo di distribuzione",
		"Batch_allocation": "Assegnazione di lotti",
		"Individual_allocation": "Assegnazione individuale",
		"Order_allocation": "Assegnazione degli ordini",
		"PNNum": "Numero PN",
		"order_number": "Numero d'ordine",
		"Allocation_result": "Risultato dell'assegnazione",
		"Assigned_successfully": "Assegnato con successo",
		"order_check": "Verifica",
		"Confirm_assignment": "Conferma assegnazione a",
		"IsIt": "è",
		"limitFormat": "Possono essere caricati solo i file nei formati \"xlsx\" e \"xls\"",
		"Ple_orderNum": "Inserisci il numero d'ordine",
		'Ple_orderNum1': "Inserisci il numero d'ordine corretto",
		'Ple_orderNum2': 'Questo ordine ha',
		'Ple_orderNum3': "collettori, confermare l'assegnazione a",
		'err_orderNum': "Nell'ordine",
		'err_orderNum1': "si prega di confermare che i collezionisti nell'ordine non sono vincolati",
		"dataogger_swith": "Aggiungi dispositivo di acquisizione dati",
		"dataogger_swithTip": "Può questo account avere il permesso di aggiungere i raccoglitori di dati",
		"account_number": "utente",
		"Role_authority": "giurisdizione",
		"authority_Management": "Gestione delle autorizzazioni",
		"Related_roles": "Ruoli correlati",
		"Ple_role1": "Seleziona il ruolo associato",
		"Ple_role2": "Inserisci il nome/ID del ruolo",
		"Add_role": "Aggiungi nuovo ruolo",
		"Edit_role": "Modifica ruolo",
		"Role_id": "ID ruolo",
		"Role_name": "Nome ruolo",
		"Ple_role3": "Inserisci il nome del ruolo",
		"Role_des": "Descrizione del ruolo",
		"Ple_role4": "Inserisci la descrizione del ruolo",
		"module": "Modulare",
		"First_page": "Pagina",
		"Secondary_page": "Pagina secondaria",
		"Function_points": "Funzione",
		"Remove_role": "Elimina ruolo",
		"Ple_role5": "Controlla i permessi dell'account",
		"No_permission_prompt": "Nessuna autorizzazione, si prega di contattare l'amministratore di livello superiore",
		"Ple_role6": "Il nome del ruolo esiste già, inserire nuovamente",
		"limit_UserTypeNum": "Superando il limite, questo tipo di account esiste già",
		"limit_UserTypeDataPermission": "Gli account dei concessionari non possono associare ruoli con permessi di dati selezionati.",
		"edit_limit_UserTypeDataPermission": "Il ruolo è associato a un account concessionario e le autorizzazioni dei dati non possono essere modificate.",
		"dataPermission": "Permesso di dati",
		"functionalPermission": "Permesso funzionale"
	},
	"group": {
		"Create_groups": "Crea gruppi",
		"Edit_groups": "Edita gruppi",
		"Groups_list": "Elenco dei gruppi",
		"Group_name": "Nome del gruppo",
		"Group_name1": "Nome del gruppo：",
		"userCount": "Numero di utenti raggruppati",
		"note": "Nota",
		"note1": "Nota：",
		"Operate": "Operazione",
		"Delete": "Cancella",
		"cancel": "Annulla",
		"finish": "Fatto",
		"confirm": "Conferma",
		"deletegroup": "Elimina gruppo",
		"deleteConfirm": "Sei sicuro di eliminare questo gruppo?",
		"entername": "Inserisci un nome del gruppo",
		"deletesuc": "Gruppo cancellato con successo",
		"creatsuc": "Gruppo creato con successo",
		"editsuc": "Gruppo modificato con successso"
	},
	"device": {
		'set': 'Istituito',
		"ownerShip": "Cambio proprietario",
    "oldOwner": "Proprietario precedente:",
    "nweOwner": "Nuovo proprietario:",
    "loading": "Caricamento...",
    "moreLoading": "Scorri per caricare altro",
		'pleaseDate': 'Seleziona una data',
		'noDate': 'Impossibile selezionare una data futura',
		'deviceDebug': 'Errore delle apparecchiature',
		'upgradeType': 'Metodo di aggiornamento:',
		'defaultUpgrade': 'Aggiornamento predefinito',
		'cloudUpgrade': 'Aggiornamento cloud',
		'continueUpgrade': "Continuare l'aggiornamento",
		'continueUpgradeSuccess': 'Erfolgreich aufgerüstet und hinzugefügt',
		'step': 'Passi iniziali:',
		'firmware_step_message': 'Inserisci i passaggi',
		'numberRlues': 'Inserisci il numero corretto di passaggi',
		'firmware_package_message': 'Seleziona firmware',
		'firmware_type_message': 'Seleziona un tipo',
		'baudrate_message': 'Seleziona Baud',
		'device_continueUpgrade': "L'equipaggiamento continua a migliorare",
		'read': 'Leggere',
		'distribute': 'Distribuisci',
		"optionTitle": "Selezionato",
		"optionTitle1": "termine",
		"optionTitle2": "La selezione dei parametri del dispositivo non può superare 4",
		"optionTitle4": "La selezione dei parametri del dispositivo non può superare 12",
		"optionTitle3": "Si prega di non selezionare le opzioni con più di 2 unità diverse",
		"upBatchDeviceTip": "Nota: l'aggiornamento dei lotti si riferisce all'aggiornamento dello stesso firmware per più dispositivi. Se non sei sicuro di quale firmware sia adatto per il tuo dispositivo, scegli con attenzione!",
		"upSuccessDevice": "Dispositivo aggiornato con successo",
		"upFailDevice": "Dispositivo aggiornato non riuscito",
		"brandDevice": "Dispositivo",
		"brand0": "Altro",
		"brand1": "Invertitore non in rete",
		"brand2": "Invertitore",
		"brand3": "Macchina integrata per lo stoccaggio di energia",
		"Allthemachines": "Tutti i dispositivi",
		"deviceList": "Elenco dei dispositivi",
		'device': 'Dispositivi',
		'datalogger': 'Raccoglitore dati',
		"dataloggerList": "Elenco dei registratori di dati",
		"followList": "Segui",
		"proList": "Elenco dei progetti",
		"pro": "Progetti",
		"deviceName": "Nome del dispositivo",
		"dataview": "Parametri in tempo reale",
		"dataTips": "Il dispositivo corrente non è in rete, non ci sono i dati in tempo reale.",
		"overview": "Panoramica statistica",
		"chart": "Grafico dei dati",
		"analysis": "Analisi dei parametri",
		"clause": "Dettagli",
		"Current_data": "Dati attuali",
		"chosenParam": "Parametro scelto",
		"optionalParam": "Parametro facoltativo",
		"reset": "Resetta",
		"energyFlow": "Grafico energetico",
		"device_name": "Nome del dispositivo",
		"device_pn": "Numero PN",
		"device_sn": "Numero SN del dispositivo",
		"device_status": "Stato del dispositivo",
		"device_upgrade1": "Ultimo record di aggiornamento",
		"device_upgradeFirmware": "Scegli un pacchetto di firmware per aggiornare il dispositivo",
		"device_upgradeTime": "Tempo di aggiornamento",
		"device_upgradeName": "Nome del firmware aggiornato",
		"device_upgradeStatus": "Stato dell'aggiornamento",
		"device_upgradeProgress": "Progresso dell'aggiornamento",
		"device_type": "Tipo del dispositivo",
		"device_code": "Protocollo della comunicazione",
		"device_code_form": "Protocollo della comunicazione：",
		"device_model": "Modello del dispositivo",
		"User_belong": "Utente",
		"field": "Controllo dei campi",
		"Datalogger_belong": "Registratore dei dati",
		"detail": "Visualizza i dettagli",
		"pageSize": "Mostra alla pagina corrente",
		"follow": "Segui",
		"unfollow": "Annulla Segui",
		"report": "Relazione",
		"timeSlot": "Periodo di tempo",
		"datalogger_pn": "PN del registratore di dati",
		"coll_alias": "Alias del registratore di dati",
		"device_address": "Indirizzo del dispositivo",
		"generation": "Pannello fotovoltaico",
		"grid": "Rete elettrica",
		"inverter": "Invertitore",
		"battery": "Batteria",
		"consumption": "Carico",
		"relay": "Micro invertitore",
		"alternator": "Generatore",
		"familyLoad": "Carico familiare",
		"solar": "Solare",
		"cur_today": "Oggi",
		"cur_thismonth": "Questo mese",
		"cur_thisyear": "Quest'anno",
		"cur_day": "Giorno",
		"cur_month": "Mese",
		"cur_year": "Anno",
		"day": "Potenza in tempo reale",
		"month": "Corrente di energia elettrica del mese",
		"year": "Corrente di energia elettrica dell'anno",
		"all": "Totale di energia elettrica",
		"pvPower": "Potenza per la produzione di energia elettrica",
		"gridPower": "Potenza di rete elettrica",
		"batteryPower": "Potenza della batteria",
		"loadPower": "Potenza di carico",
		"generated": "Quantità di carica elettrica generata",
		"charged": "Quantità di carica elettrica di carico",
		"discharged": "Quantità di carica elettrica di scarico",
		"sold": "Vendita della quantità di carica elettrica",
		"bought": "acquisto della quantità di carica elettrica",
		"used": "Consumo della quantità di carica elettrica",
		"normal": "Normale",
		"offline": "Disconnesso",
		"warning": "Attenzione",
		"fault": "Guasto",
		"standby": "In attesa",
		"universal_firmware": "Firmware universale",
		"communication_firmware": "Firmware comunicale",
		"control_firmware1": "Controllo firmware 1",
		"control_firmware2": "Controllo firmware 2",
		"control_firmware_bms": "Firmware BMS",
		"control_firmware_slavmcu": "Firmware SlavMCU",
		"default": "Predefinito",
		"modifySuc": "Modificato con successo",
		"instruction_response": "Invio del comando in corso, in attesa di risposta…",
		"debug_suc": "Debug riuscito",
		"Debugfail": "Debug fallito. Il dispositivo non è in rete",
		"Send_suc": "Comando inviato con successo",
		"Send_Input": "Inserisci il valore dell'operazione da inviare",
		"Send_fail": "Invio del comando non riuscito",
		"fileExceed": "Il file è troppo grande",
		"uploadSuccess": "Caricamento riuscito",
		"error1": "Possono essere caricati solo i file nei formati \".bin\" e \".hex\"",
		"file_fist": "Scegli prima il firmware da aggiornare",
		"updatefail": "Aggiornamento non riuscito. il registratore dati non è in rete. Oppure controlla se funziona la comunicazione col registrar dei dati.",
		"update_suc": "Aggiornato con successo",
		"deleteSuc": "Rimosso con successo",
		"Operation": "Operazione",
		"edit": "Modifica",
		"debug": "Debug",
		"upgrade": "Aggiornamento di massa",
		"upgrade1": "Aggiornamento",
		"more": "Più Azioni",
		"one_click_read": "Leggi con un Clic",
		'cloudsUpgrade': 'Aggiornamento cloud',
		"queryUpgrade": "Ricerca di lotti per progresso di aggiornamento ",
		"control": "controllo",
		"delete": "Cancella",
		"modify_alias": "Modifica dispositivo",
		"serial_number": "Numero SN del dispositivo：",
		"device_alias": "Nome del dispositivo：",
		"cancel": "Annulla",
		"confirm": "Conferma",
		"Device_sn": "Numero di serie del dispositivo",
		"Device_pn": "PN del dispositivo",
		"Instruction": "Istruzioni：",
		"such_as": "Ad esempio AA BB CC DD EE FF",
		"return_content": "Ritorna al contenuto:",
		"send": "Invia istruzioni",
		"clear_data": "Cancella dati",
		"clear_val": "Cancella",
		"copy_val": "Copia",
		"copy_val_yes": "Copia riuscita",
		"copy_val_no": "Copia non riuscita",
		"Field_Name": "Campo del nome",
		"Unit": "unità",
		"current_val": "Valore corrente",
		"Battery_voltage": "Tensione della batteria",
		"Magnification": "Moltiplicatore",
		"Send_Command": "Invia comando",
		"device_upgrade": "Aggiorna il firmware del dispositivo",
		'device_cloudsUpgrade': 'Aggiornamento cloud dispositivo',
		"select_firmware": "Firmware：",
		"select_file": "Seleziona firmware",
		"firmware_type": "Tipi dei firmware：",
		"select_type": "Seleziona il tipo di firmware",
		"upgrade_brate": "Tasso di Baud：",
		"select_brate": "Seleziona il tasso di Baud",
		"Upload": "Carica",
		"Upload1": "Carica il nuovo firmware",
		"confirm_deldte": "Conferma di eliminare?",
		"deleteDevice": "Elimina il dispositivo",
		"Today_income": "Reddito giornaliero per la produzione di energia",
		"Cumulative_income": "Entrate totali dalla produzione di energia",
		"sellProfit_Today": "Entrate giornaliere delle vendite di energia elettrica",
		"sellProfit_Total": "Totale delle entrate derivanti dalle vendite di energia elettrica",
		"buyProfit_Today": "Spese correnti di acquisto di energia elettrica",
		"buyProfit_Total": "Spese totali di acquisto di energia elettrica",
		"noAuth": "Nessun utente, nessun autorizzazione di visualizzare",
		"statistic": "Statistiche",
		"protocolStatistic": "Statistiche del protocollo di comunicazione",
		"chooseProtocol": "Seleziona protocollo:",
		"parameter": "parametro",
		"value": "valore",
		"Upgrading": "Aggiornamento in corso, attende per favore",
		"System_Failed": "Il sistema non è riuscito ad avviare il processo di aggiornamento del dispositivo a causa di comunicazioni anomale o altri motivi",
		"Device_Offline": "Il dispositivo o il registratore di dati non è in rete",
		"In_Upgrading": "Il dispositivo oil registratore di dati è già in frase di aggiornamento",
		"Update_Completed": "Aggiornamento completato",
		"Voltage": "Tensione",
		"Electric": "corrente elettrica",
		"power": "potenza",
		"frequency": "Frequenza",
		"Input_form": "Tabella di input",
		"add": "Aggiungi",
		"Output_table": "Tabella di output",
		"Please_parameter": "Seleziona un parametro",
		"Successfully_modified": "Modificato con successo",
		"edit_control": "Modifica l'autorizzazione di controllo del dispositivo",
		"Equipment_agreement": "Protocollo del dispositivo",
		"Check_all": "Controlla tutto",
		"Cancel_all": "Annulla tutto",
		"administrator_cansee": "Rappresentante delle autorizzazioni selezionato: visibile all'amministratore e invisibile al rappresentante non selezionato.",
		"person_cansee": "Rappresentante delle autorizzazioni selezionato: visibili al proprietario e invisibile al rappresentante non selezionato.",
		"admin_authority": "Autorità di amministratore",
		"person_authority": "Autorità del proprietario",
		"noDataPlease": "Nessun dato, seleziona l'ora di nuovo",
		"Sn_deviceName": "SN / Nome dispositivo / PN / Utente",
		"deviceInfo": "Informazioni",
		"alarmInfo": "Allarme",
		"deviceNo": "Non hai ancora aggiunto un dispositivo",
		"showParam": "Visualizzazione dei parametri",
		"selecParameters": "Parametro selezionato",
		"refresh": "Aggiorna",
		"obtain": "Ottieni",
		"moveResults": "Sposta risultati",
		"moveSuc": "Spostamento riuscito",
		"maxSelect": "È possibile scegliere solo fino a un massimo di 7 parametri",
		"minSelect": "Scegli almeno 1 parametro",
		"loadMore": "Carica di più…",
		"upDevice": "Aggiornamento del dispositivo",
		'addUpgrade': 'Aggiungi attività di aggiornamento',
		'upgradeProgress': 'Aggiornamento attuale',
		'deviceUpgradeProgress': "Progressi dell'aggiornamento delle apparecchiature",
		'addUpgradeSuccess': 'Aggiunta con successo',
				"unbind_tips": "Il dispositivo non è associato a un proprietario, associare prima il proprietario",
		"device_code1": "Codice dispositivo"
	},
	"alarm": {
		"device_Warning": "Allarme del dispositivo",
		"device_Error": "Errore del dispositivo",
		"device_Fault": "Guasto del dispositivo",
		"Alarm_Event": "Evento di allarme",
		"Today_Alarm": "Quantità di allarmi d'oggi",
		"Alarm_Type": "Tipo di allarme",
		"Device_Type": "Tipo del dispositivo",
		"Alarm_Status": "Stato di elaborazione",
		"Alarm_List": "Elenco degli avvisi",
		"deletes": "Cancella",
		"tips": "Consigli",
		"details": "Dettagli",
		"alarmDetails": "Dettagli dell'allarme",
		"alarmInfo": "Situazione di allarme",
		"alarmDevice": "Informazioni sul dispositivo",
		"delete_alarm": "Sei sicuro di eliminare questo avviso?",
		"Cancel": "Annulla",
		"Confirm": "Conferma",
		"Close": "Chiudi",
		"processed": "Risolto",
		"untreated": "Non risolto",
		"allAlarm": "Totale dei eventi di allarme",
		"alarmStatus": "Totale di stato di elaborazione su allarme",
		"warningTitle": "Quantità di allarmi negli ultimi 7 giorni",
		"faultTitle": "Quantità di guasti negli ultimi 7 giorni",
		"alarmNum": "Quantità di allarmi",
		"faultNum": "Quantità di guasti",
		"all": "Tutti",
		"warning": "Allarme",
		"error": "Errore",
		"fault": "Guasto",
		"offline": "Disconnesso",
		"inverter": "Invertitore",
		"monitor": "Rilevatore ambientale",
		"smart_meters": "Misuratore consumo elettrico",
		"combining_manifolds": "Scatola combinata",
		"Camera": "Fotocamera",
		"Battery": "Batteria",
		"Charger": "Caricatore",
		"storage": "Macchina per lo stoccaggio di energia",
		"Prevent_arcing_island": "Dispositivo anti-isola",
		"Microinverter": "Micro invertitore",
		"Occurrence_time": "Tempo accaduto:",
		"endtime": "Ora di fine",
		"Device_Name": "Nome del dispositivo",
		"Device_PN": "Numero PN del registratore di dati",
		"Plant": "Centrale elettrica",
		"Alarm_Code": "Codice allarme",
		"Alarm_Describe": "Descrizione dell'allarme",
		"Device_SN": "Numero SN del dispositivo",
		"device_alias": "Alias del dispositivo",
		"device_address": "Indirizzo del dispositivo",
		"User": "Utente",
		"Status": "Stato",
		"Operation": "Operazione",
		"Delete_selected": "Elimina selezionato",
		"deleted_successfully": "Allarme eliminato con successo!",
		"Alarm_Msg": "Nuovo messaggio",
		"Intro_Msg": "Guida per principianti",
		"Alarm_Read": "Hai letto tutte le notifiche di allarme",
		"Alarm_data": "Non ci sono ultime notizie per ora!",
		"Alarm_Message": "Il tuo",
		"Alarm_Message1": "Appare il dispositivo",
		"curSelected": "Attualmente selezionato",
		"_Data": "Dati",
		"more": "Di più",
		"ruleManage": "Gestione delle Regole di filtraggio degli avvisi",
		"ruleNew": "Nuova regola",
		"ruleName": "Nome della regola",
		"timeSlot": "Periodo di tempo",
		"deviceType": "Tipo del dispositivo",
		"deviceFilter": "Filtro del dispositivo",
		"alrmType": "Filtro per tipi di allarme",
		"alrmDes": "Descrizione dell' avviso filtro",
		"filterHistory": "Cronologia dei filtri",
		"clearHistory": "Cancella cronologia",
		"view": "vedi",
		"back": "Indietro",
		"exportArchive": "Esporta allarme archiviato",
		"archiveRecord": "Archivio",
		"archiveTip": "L'elenco include tutti gli allarmi non elaborati e i record elaborati entro 7 giorni"
	},
	"datalogger": {
		'activeStatus': 'Stato di attivazione',
		'Active': 'Attivato',
		'notActive': 'Non attivo',
		'timeZone': 'Fuso orario',
		"please_title": "Inserire 'YES' per confermare il ripristino di fabbrica",
		"frequency": "Frequenza di raccolta",
		"heartbeat": "Battito cardiaco",
		"warehousing_time": "tempo di stoccaggio",
		"start_address": "Indirizzo di inizio sondaggio",
		"deadline_address": "Indirizzo limite del sondaggio",
		"title_usr": "Questo raccoglitore di dati non ha un utente affiliato",
		"datalogger_log": "Log",
		"min_addr": "indirizzo minimo",
		"max_addr": "Indirizzo massimo",
		"transmission": "Identificazione pura trasparente",
		"transparent_set": "Set di protocollo trasparente puro",
		"devcode": "Codice produttore di apparecchiature",
		"protocol_code": "Protocol producer code",
		"domain_name": "Nome di dominio online",
		"transmission1": "Modalità di raccolta locale",
		"transmission2": "modalità trasparente pura",
		"noDate": "Seleziona una data entro 3 giorni",
		"paramSetting": "Parameter settings",
		"paramName": "Parameter name",
		"paramPar": "Numero parametro",
		"paramVal": "Il valore del parametro",
		"dataloggerView": "Dati raccolti",
		"describe": "Descrizione",
		"field_name": "Nome campo",
		"checkVal": "Valore numerico",
		"resetTitle1": "Sei sicuro di voler resettare il raccoglitore di dati? (1: renderlo nuovamente registrabile, 2: cancellare i dispositivi subordinati, 3: eliminare tutti i dati sotto il raccoglitore)",
		"unbingTitle": "Sei sicuro di voler sbloccare il raccoglitore di dati? (1: Liberare l'amministratore del rivenditore; 2: Rebind, accedi al corrispondente amministratore del rivenditore per aggiungere il raccoglitore di dati)",
		"getTitle": "Acquisizione parametri",
		"postTitle": "Parameter Settings",
		"debugeTitle": "Setting up debugging",
		"getName": "Acquisizione dei parametri (decimale)",
		"postName": "Parametro numero (decimale)",
		"debugeName": "Command:",
		"getVal": "Valore corrente:",
		"postVal": "Impostazione del valore:",
		"debugeVal": "Risultato:",
		"debugeAddr": "Indirizzo del dispositivo:",
		"getSucc": "Ottenuto con successo",
		"postSucc": "Imposta correttamente",
		"debugeSucc": "Rilasciato con successo",
		"copyVal": "Copy value",
		"huoqu": "Get",
		"shezhi": "Impostazioni",
		"xiafa": "Emissione comando",
		"copy": "Copia riuscita",
		"flowCard": "Nessuna carta valida trovata",
		"province": "Provincia/Regione",
		"city": "Città",
		"county": "Contea/distretto",
		"country": "Paese",
		"Flowcard_status": "Stato della scheda di flusso",
		"GPRS_traffic": "Traffico GPRS",
		"upBatchDataloggerTip": "Nota: l'aggiornamento dei lotti si riferisce all'aggiornamento dello stesso firmware per più dispositivi. Se non sei sicuro di quale firmware sia adatto per il tuo dispositivo, scegli con attenzione!",
		"upSuccessDatalogger": "Registratore dei dati aggiornato con successo",
		"upFailDatalogger": "Aggiornamento del registratore dei dati non riuscito",
		"Datalogger_Status": "Stato del registratore di dati",
		"com_method": "Modalità di comunicazione",
		"Datalogger_PN": "Numero PN del registratore di dati",
		"Datalogger_List": "Elenco dei registratori di dati",
		"Datalogger_Name": "Nome del registratore di dati",
		"Ple_PN": "Si prega di inserire il numero PN del registratore di dati",
		"Ple_Alias": "Inserisci il nome del registratore dei dati",
		"Datalogger_type": "Modello del registratore di dati",
		"Datalogger_model": "Modello",
		"Datalogger_method": "Modalità di comunicazione",
		"Status": "Stato",
		"usr_belong": "Utente",
		"administrator": "Amministratore",
		"Communication_balance": "Saldo delle comunicazioni",
		"load": "Carico",
		"Firmware_Version": "Versione del firmware",
		"signal": "Segnale",
		"Operation": "Operazione",
		"edit": "Modifica",
		"reboot": "Riavvia",
		"unbind": "Sbloccato",
		"more": "Di più",
		"resetData": "Ripristina i dati",
		"unbindUsr": "Sblocca il proprietario",
		"debug": "Debug",
		"upgrade": "Aggiornamento",
		"delete": "Cancella",
		"deleteTitle": "Cancella il registratore di dati",
		"reset": "Resetta",
		"resetCode": "Inserisci SI per confermare",
		"modify_datalog": "Modifica delle informazioni del registro dati",
		"cancel": "Annulla",
		"confirm": "Conferma",
		"datalogger_debug": "Debug del datalogger",
		"communication_address": "Indirizzo di comunicazione：",
		"Instruction": "Istruzioni：",
		"such_as": "Ad esempio AA BB CC DD EE FF",
		"return_content": "Ritorna al contenuto:",
		"send": "Invia istruzioni",
		"check": "Verifica",
		"InstructionType": "Formato istruzione",
		"endMarker": "Marcatore finale",
		"noMarker": "Senza marcatore finale",
		"noCheck": "Senza verifica",
		"InstructionIssue": "Invia istruzione",
		"Insufficient": "Numero insufficiente",
		"clear_data": "Cancella dati",
		"device_upgrade": "Aggiorna il firmware del dispositivo",
		"select_firmware": "Firmware：",
		"select_file": "Seleziona firmware",
		"Upload": "Carica",
		"prompt_message": "Messaggio richiesto",
		"confirm_deldte": "Dopo la cancellazione del registratore dati, non hai autorizzazione di gestire tutti i dati relativi al registratore dati?",
		"Normal": "Normale",
		"Online": "Online",
		"Offline": "Disconnesso",
		"Normal1": "Stato online",
		"Offline1": "Stato offline",
		"Allstate": "Tutto lo stato",
		"modifySuc": "Modificato con successo",
		"resetSuc": "Resettatto con successo",
		"unbindSuc": "Sbloccato con successo",
		"devaddrfail": "L'indirizzo postale non può essere vuoto",
		"Debugfail": "Debug fallito, il registratore di dati è offline",
		"instruction_response": "Invio del comando in corso, in attesa di risposta…",
		"fileExceed": "Il file è troppo grande",
		"uploadSuccess": "Caricamento riuscito",
		"error1": "Possono essere caricati solo i file nei formati \".bin\" e \".hex\"",
		"file_fist": "Scegli prima il firmware da aggiornare",
		"updatefail": "Aggiornamento non riuscito. il registratore dati non è in rete. Oppure controlla se funziona la comunicazione col registrar dei dati.",
		"update_suc": "Aggiornato con successo",
		"deleteSuc": "Rimosso con successo",
		"debug_suc": "Debug riuscito",
		"create": "Crea",
		"addSuc": "Il registratore di dati aggiunto con successo",
		"add": "Aggiungi dispositivo",
		"addScq": "Aggiungi il registratore di dati",
		"batchAddScq": "Aggiunti dei lotti registratori dati",
		"editDatalogger": "Modifica registratore di dati",
		"editDataloggerName": "Edita registratore di dati",
		"resetDataloggerName": "Ripristina il registratore di dati",
		"unbindDataloggerName": "Sblocca registratore di dati",
		"resetDataloggerExplain": "Questa funzione viene utilizzata principalmente per facilitare i produttori a svuotare i dati di test cloud sui dispositivi. Dopo aver reimpostato il registratore dati, i dati storici del dispositivo verranno svuotati. Una volta effettuato, i dati storici non verrano recuperati. Si prega di operare con attenzione!",
		"unbindDataloggerExplain": "Questa funzione viene utilizzata principalmente per facilitare i produttori a sbloccare il conto di prova (proprietario) con il registratore di dati dopo il test pre-spedizione. Si prega di prendere questa funzione con attenzione. Una volta effettuato, il cliente deve legare il registratore di dati di nuovo.",
		"rebootDataloggerName": "Riavvia il registratore di dati",
		"rebootDataloggerSuc": "Registratore di dati riavviato con successo",
		"fixOnRebootDataloggerName": "Conferma di riavviare il registratore di dati：",
		"fixOnRebootDataloggerName1": "è?",
		"unbindTitle": "Inserisci \"SÌ\" per confermare di voler sbloccare il registratore dati dal proprietario terminale attuale.",
		"resetTitle": "Inserire \"SÌ\" per confermare di ripristinare il registratore dati.",
		"editSuc": "Registratore di dati modificato con successo",
		"basic_info": "Informazioni di base",
		"datalogger_pn": "PN del registratore di dati：",
		"datalogger_name": "Nome del registratore di dati：",
		"nominalPower": "Potenza nominale",
		"install_date": "Data di installazione",
		"installer": "Installatore",
		"location_info": "Informazioni sulla posizione",
		"location_info1": "Informazioni geografiche",
		"district": "Distretto amministrativo",
		"address": "La posizione del registratore di dati",
		"dataloggerAddress": "Indirizzo dettagliato",
		"enterPosition": "Indirizzo del registratore dati di input",
		"longi_lati": "Indirizzo del registratore dati di input",
		"latitude": "Latitudine",
		"longitude": "Longitudine",
		"currentAddress": "Indirizzo attuale：",
		"timezone": "Fuso orario",
		"timezone1": "Longitudine e latitudine",
		"cp1": "latitudine",
		"cp2": "longitudine",
		"cp3": "Si prega diInserire la potenza nominale",
		"cp4": "Si prega di selezionare valuta di benifici",
		"cp5": "Inserisci il nome del dispositivo",
		"cp6": "Seleziona un progetto",
		"cp7": "Seleziona latitudine e longitudine",
		"lonRange": "Numeri nella gamma di longitudine -180-180",
		"latRange": "Numeri nell'intervallo di latitudine da -90 a 90",
		"cp9": "Inserisci l'indirizzo corrente",
		"cp10": "Inserisci il nome del progetto",
		"income_info": "Informazioni sui benifici",
		"currency": "Valuta di Benifici：",
		"buyProfit": "Prezzo di acquisto dell'elettricità：",
		"sellProfit": "Prezzo di vendita dell'elettricità：",
		"unitProfit": "Prezzo del consumo elettrico：",
		"generateProfit": "Prezzo di produzione di energia elettrica：",
		"noNegative": "Inserisci un numero non negativo",
		"buyProfitNew": "Prezzo di acquisto dell'elettricità",
		"sellProfitNew": "Prezzo di vendita dell'elettricità",
		"generateProfitNew": "Prezzo di produzione di energia elettrica",
		"add_datalogger": "Aggiungi il nuovo registratore di dati",
		"add_suc": "Aggiunto con successo",
		"basicInfo": "Informazioni di base",
		"connectionInfo": "Informazioni di connessione",
		"finishAdding": "Termina l'aggiunta",
		"addResults": "Aggiungi risultati",
		"addedSuccessfully": "Aggiunto con successo",
		"finish": "Fatto",
		"continueAdding": "Continua ad aggiungere",
		"nowNoAdd": "Non ancora aggiunto",
		"reAdd": "Aggiungi di nuovo",
		"editResults": "Modifica risultati",
		"resetResults": "Ripristina i risultati",
		"unbindResults": "Risultati sbloccati",
		"delResults": "Elimina risultati",
		"locationTip": "Suggerimento amichevole: inserire a mano è disponibile quando il posizionamento è impreciso o fallito",
		"upDatalogger": "Aggiornamento del registratore dei dati",
		"dataloggerTipName": "Il collezionista è stato aggiunto, aggiunto da",
				"batch_edit_datalogger": "Modifica datalogger in blocco",
				"upload_column_tips": "Promemoria: Colonna A è PN del datalogger, Colonna B è numero di carico, Colonna C è baud rate, Colonna D è protocollo di comunicazione, Colonna E è codice produttore dispositivo, Colonna F è codice produttore protocollo, Colonna G è modalità di raccolta, Colonna H è indirizzo minimo, Colonna I è indirizzo massimo, nessun titolo necessario, vedere immagine seguente",
				"upload_csv_tips": "Promemoria: Il formato del file deve essere csv, vedere immagine seguente per il contenuto",
				"click_enlarge": "Clicca per ingrandire i dettagli",
						"collector_expire_time": "Scadenza del collettore",
						"collection_cycle": "Ciclo di raccolta",
								"ascii_display": "Visualizzazione ASCII:"
	},
	"map": {
		"sn": "SN dispositivo:",
		"datalogger": "Nome del registratore di dati：",
		"address": "Indirizzo del dispositivo："
	},
	"rate": {
		"device_status": "Stato del dispositivo",
		"datalogger_pn": "PN del registratore di dati",
		"datalogger_pns": "PN del registratore di dati：",
		"rate_list": "Elenco delle tariffe",
		"datalogger_name": "Nome del registratore di dati",
		"status": "Stato",
		"Income_currency": "Valuta di Benifici",
		"Income_currencys": "Valuta di Benifici：",
		"generate_Rate": "Tasso di produzione di energia elettrica",
		"generate_Rates": "Tasso di produzione di energia elettrica:",
		"sell_Rate": "Tasso di vendita dell'elettricità",
		"sell_Rates": "Tasso di vendita dell'elettricità:",
		"buy_Rate": "Tasso di acquisto di elettricità",
		"buy_Rates": "Tasso di acquisto di elettricità:",
		"operating": "Operazione",
		"edit": "Modifica",
		"rate": "tasso",
		"cancel": "Annulla",
		"confirm": "Conferma",
		"modifySuc": "Modificato con successo",
		"resetSuc": "Resettatto con successo",
		"unbindSuc": "Sbloccato con successo"
	},
	"auxiliary": {
		"auxiliaryFunction": "Funzioni ausiliarie",
		'chartSupplement': 'Grafico reale',
		'realChart': "Dopo l'apertura, il grafico visualizza dati reali.",
	},
	"strategy": {
		'strategyUpgrade': 'Elenco delle strategie di aggiornamento',
		'to': 'Ritorno',
		'UpgFirmware': 'Gestione firmware locale',
		'strategyIntro': 'Panoramica del processo di aggiornamento locale',
		'strategyInfor': 'Informazioni sulla politica di aggiornamento',
		'strategyIntro1': "Descrizione: Questo modulo di funzione è solo per l'aggiornamento del firmware locale Bluetooth. Se si desidera aggiornare il firmware di dispositivi come Wi Fi o 4G, passare a [Operazione di aggiornamento della lista dei dispositivi di gestione dei dispositivi]",
		'stategyStep2': 'Nuovo pacchetto di versione firmware',
		'stategyStep3': 'Carica file di pacchetto della versione del firmware nella gestione locale del firmware',
		'stategyStep4': 'Aggiornamento locale APP',
		'stategyStep5': "Dopo che la strategia entra in vigore, l'APP riceve un promemoria di aggiornamento e può eseguire l'aggiornamento localmente",
		'stategyStep6': 'Aggiungi strategia di aggiornamento',
		'stategyStep7': "Aggiungere una nuova strategia nell'elenco delle strategie di aggiornamento, selezionare Upgrade Firmware, impostare il metodo di aggiornamento e prendere effetto, associare il dispositivo di aggiornamento e generare la strategia di aggiornamento",
		'stategyStep8': 'Visualizza record di aggiornamento',
		'stategyStep9': "Visualizza lo stato e i risultati dell'aggiornamento del dispositivo",
		'stategyDetail': 'Nome della politica',
		'stategyDetail1': 'Aggiorna firmware',
		'stategyDetail2': 'Dimensione del pacchetto firmware (KB)',
		'stategyDetail3': 'Tipo firmware',
		'stategyDetail4': 'Tasso di baud',
		'stategyDetail5': 'Metodo di aggiornamento',
		'stategyDetail6': "Progresso dell'aggiornamento",
		'stategyDetail7': 'Stato della politica',
		'stategyDetail8': 'orario di entrata in vigore',
		'stategyDetail9': 'Tempo di scadenza',
		'upgradeList': 'Aggiorna elenco record',
		'add_strategy': 'Elenco delle strategie di aggiornamento',
		'strategy_time': 'Tempo effettivo',
		'strategy_code': 'Codifica politica',
		'strategy_name': 'Nome della politica',
		'strategy_desc': 'Descrizione della politica',
		'strategy_firmware': 'Aggiorna firmware',
		'strategy_type': 'Tipo firmware',
		'strategy_baudrate': 'Tasso di baud',
		'uprade_type': 'Metodo di aggiornamento',
		'uprade_name': 'Forza aggiornamento',
		'uprade_name1': 'Aggiornamento suggerito',
		'uprade_result': "Risultati dell' aggiornamento",
		'uprade_success': 'Aggiornamento riuscito',
		'uprade_fail': 'Aggiornamento fallito',
		'uprade_status': "Stato dell'aggiornamento",
		'uprade_time': 'Tempo di aggiornamento',
		'strategy_number': 'Numero di oggetti aggiornati',
		'strategy_status': 'Stato della politica',
		'start_time': 'ora di inizio',
		'end_time': 'Tempo di scadenza',
		'edit': 'Modifica',
		'edit_strategy': 'Modifica criterio',
		'view': 'Verifica',
		'view_strategy': 'Visualizza criteri',
		'cancel': 'Annulla',
		'cancel_strategy': 'Politica di cancellazione',
		'force_upgrade': 'Forza aggiornamento',
		'suggested_upgrade': 'Aggiornamento suggerito',
		'In_effect': 'In effetti',
		'expired': 'Scaduto',
		'Not_started': 'Non iniziato',
		'Not_upgraded': 'Non aggiornato',
		'Yes_started': 'Aggiornamento',
		'policy_information': 'Informazioni politiche',
		'associated_device': 'Dispositivi associati',
		'completion_strategy': 'Strategia di completamento',
		'upgrade_strategy_list': 'Elenco delle strategie di aggiornamento',
		'Next': 'Passo successivo',
		'TOP': 'Fase precedente',
		'confirm': 'Conferma',
		'go_back': 'Ritorno',
		'strategy_detail': 'Dettagli della strategia',
		'strategy_search': 'Codice della politica/Nome della politica',
		'strategy_upgrade_search': 'SN device/PN datalogger',
		'upgrade_remind': 'Promemoria di aggiornamento',
		'remind_desc': 'Descrizione promemoria',
		'default_desc': 'Descrizione predefinita',
		'default_desc1': "Questo dispositivo deve essere aggiornato a una versione superiore prima di poter essere utilizzato. Fare clic su 'Forza aggiornamento' per eseguire l'aggiornamento. Non scollegare la connessione Bluetooth e garantire un funzionamento regolare della rete durante l'aggiornamento.",
		'message_name': 'Inserisci un nome della politica',
		'message_desc': 'Inserisci una descrizione della politica',
		'message_firmware': 'Seleziona firmware',
		'message_type': 'Selezionare il tipo di firmware',
		'message_baudrate': 'Selezionare il baud rate',
		'message_timezone': 'Seleziona un fuso orario',
		'message_time': 'Seleziona un orario valido',
		'message_uprade_type': 'Seleziona il tipo di aggiornamento',
		'delete_firmware': 'Sei sicuro di voler annullare questa politica?',
		'delete_desc': "Dopo la cancellazione, non sarà possibile recuperare e la strategia di aggiornamento selezionata non sarà in grado di notificare al dispositivo di eseguire l'aggiornamento",
		'Upgrade_tip': 'Selezionare il dispositivo associato alla politica',
		'Upgrade_result': 'Aggiunta con successo',
		'start_date': 'Data di entrata in vigore',
		'End_date': 'Data di scadenza',
		"limits":     "Suggerimento: nel file caricato la colonna A deve contenere il PN del data-logger; il titolo non è necessario — vedi l’esempio nell’immagine sotto.",
		"mueas":      "Strategia di aggiornamento",
		"upNum":      "Numero di dispositivi da aggiornare",
		"deletCL":    "Elimina strategia",
		"deletCL_TEST":"Sei sicuro di voler eliminare questa strategia?",
		"ONE_UP":     "Aggiornamento singolo dispositivo",
		"MO_UP":      "Aggiornamento bulk dispositivi",
		"MO_text": "Importato con successo",
"MO_tex1": "Duplicato",
"MO_tex3": "Non trovato",
"MO_tex2": "Organizzazione",
"MO_tex4": "Il firmware è usato da strategia attiva, non eliminabile",
	},
	"cloudsUpgarde": {
		'cloudsFirmware': 'Firmware di aggiornamento cloud',
		'cloudsFirmwareList': 'Elenco aggiornamenti cloud',
	},
	"upgradeManagement": {
		'create': 'Stabilire',
		'cancel': 'Annulla',
		'confirm': 'Conferma',
		'upload_firmware': 'Carica firmware',
		'edit_firmware': 'Modifica firmware',
		'download_firmware': 'Scarica firmware',
		'delete_desc': "Dopo l'eliminazione, non sarà possibile recuperare e la strategia di aggiornamento selezionata per questo firmware non sarà in grado di aggiornare il dispositivo",
		'eidt_success': 'Modificato con successo',
		'delete_success': 'Annullato con successo',
		'delete_success1': 'Eliminato con successo',
		'download_success': 'Download riuscito',
		'firmware_name': 'Nome pacchetto firmware',
		'Firmware_Version': 'Numero di versione',
		'please_upgrade': 'Seleziona il file di caricamento',
		'upgrade_success': 'Caricamento del firmware con successo',
		'please_input': 'Inserisci',
		'Remarks': 'Descrizione del firmware',
		'Upload': 'Carica firmware',
		'download_firmware_prompt': 'Sei sicuro di voler scaricare questo firmware?',
		'upgrade_file_format': 'Può caricare solo in formato. bin/. hex, non può superare 1MB',
		'upgrade_file_format1': 'Può caricare solo in formato. bin/. hex',
		'upgrade_file_format2': 'Il file non può superare 1MB',
		'firmwareName_empty': 'Il nome del firmware non può essere vuoto',
		'firmwareVersion_empty': 'Il numero di versione non può essere vuoto',
		"download_exception": "Scarica eccezione, riprova più tardi",
		"upload_result": "Risultato caricamento",
	},
	"project": {
		"choice": "Scelta",
		"move": "Sposta",
		"manageProject": "la funzione della gestione dei progetti",
		"project": "Progetto",
		"defaultProject": "Progetto predefinito",
		"projectName": "Nome del progetto",
		"projectRemark": "Descrizione del progetto",
		"projectId": "ID progetto",
		"createProject": "Crea progetto",
		"createResults": "Crea risultati",
		"createSuc": "Creato con successo",
		"editProject": "Modifica progetto",
		"editResults": "Modifica risultati",
		"editSuc": "Modificato con successo",
		"delProject": "Elimina progetto",
		"delResults": "Elimina risultati",
		"delSuc": "Rimosso con successo",
		"upgradeResults": "Risultato dell' aggiornamento",
		"upgradeSuc": "Aggiornato con successo",
		"back": "Indietro",
		"placeholder": "Ricerca nome del dispositivo/ SN /PN",
		"modifySuc": "Successo",
		"upload": "Carica immagini",
		"limit": "(Dimensioni dell'immagine non supera più di 1M)",
		"moveTo": "Sposta a",
		"moveSelect": "Spostamento selezionato",
		"deviceSn": "Numero SN del dispositivo",
		"tipCard": "Carta",
		"tipList": "Elenco",
		"tipSearchSN": "Per dispositivo",
		"tipSearchPN": "Per registratore dei dati",
		"energyCurrent": "Potenza corrente",
		"energyDate": "Produzione di energia elettrica del giorno",
		"energyMonth": "Produzione di energia elettrica del mese",
		"energyYear": "Produzione di energia elettrica dell'anno",
		"energyTotal": "Totale energia elettrica"
	},
	"constant": {
		"renminbi": "RMB(￥)",
		"meiyuan": "USD($)",
		"ouyuan": "EURO(€)",
		"aoyuan": "AUD ($A)",
		"yingbang": "GBP(£)",
		"gangbi": "HKD(HK $)",
		"ruidian": "Corona Svedese (Kr)",
		"lubi": "Rupia Indiana (₹)",
		"moxige": "MXN(Mex $)",
		"baxi": "REAl (R $)",
		"Pakistani": "Rupie Pakistane (Rs)",
		"Rand": "Rand sudafricano (R)",
		"gmt0": "(GMT +00:00) Dublino, Edimburgo, Lisbona, Londra, Casablanca, Coordinated Universal Time",
		"gmt_1": "(GMT +01:00) Paris, Madrid, Copenhagen, Rome, Vienna, Berlin, Amsterdam, West Africa",
		"gmt_2": "(GMT +02:00) Amman, Damasco, Cairo, Atene, Gerusalemme, Istanbul",
		"gmt_3": "(GMT +03:00) Baghdad, Kuwait, Riyadh, Nairobi, Teheran",
		"gmt_4": "(GMT +04:00) Abu Dhabi, Muscat, Yerevan",
		"gmt_5": "(GMT +05:00) Islamabad, Karachi",
		"gmt_55": "(GMT+05:30) New Delhi",
		"gmt_6": "(GMT +06:00) Dhaka, Astana, Ekaterinburg",
		"gmt_65": "(GMT +06:30) Myanmar",
		"gmt_7": "(GMT +07:00) Bangkok, Hanoi, Giacarta, Novosibirsk",
		"gmt_8": "(GMT +08:00) Beijing, Chongqing, Regione amministrativa speciale di Hong Kong, Urumqi, Taipei, Kuala Lumpur, Singapore",
		"gmt_9": "(GMT +09:00) Osaka, Tokyo, Seoul",
		"gmt_10": "(GMT +10:00) Brisbane, Guam, Canberra, Melbourne, Sydney",
		"gmt_11": "(GMT +11:00) Isole Salomone, Vladivostok, Nuova Caledonia",
		"gmt_12": "(GMT +12:00) Auckland, Wellington, Fiji, Magadan",
		"gmt_13": "(GMT +13:00) Nukualofa",
		"gmt_neg_1": "(GMT -01:00) Isole Capo Verde, Azzorre",
		"gmt_neg_2": "(GMT -02:00) Mid-Atlantic",
		"gmt_neg_3": "(GMT -03:00) Brasilia, Buenos Aires, Groenlandia, Cayenne",
		"gmt_neg_4": "(GMT -04:00) Atlantic Time (Canada), Cuiaba, La Paz, Santiago",
		"gmt_neg_5": "(GMT -05:00) Eastern Time (USA e Canada), Indiana (Eastern Time)",
		"gmt_neg_6": "(GMT -06:00) Ora Centrale (Stati Uniti e Canada), America Centrale, Città del Messico, Monterrey, Guadalajara",
		"gmt_neg_7": "(GMT -07:00) Mountain Time (Stati Uniti e Canada), Chihuahua, La Paz, Mazatlan, Arizona",
		"gmt_neg_8": "(GMT -08:00) Ora del Pacifico (Stati Uniti e Canada), Bassa California",
		"gmt_neg_9": "(GMT -09:00) Alaska",
		"gmt_neg_10": "(GMT -10:00) Hawaii",
		"gmt_neg_11": "(GMT -11:00) Samoa",
		"gmt_neg_12": "(GMT -12:00) Linea internazionale di cambio di data ovest"
	},
	"basic": {
		"modifySuc": "Modificato con successo!",
		"Personal_info": "Modifica informazioni",
		"User_name": "Nome utente：",
		"User_name1": "Nome utente",
		"Nickname": "Il soprannome：",
		"Nickname1": "Il soprannome",
		"editNickname": "Modifica il soprannome",
		"Ple_Nickname": "Inserisci un soprannome",
		"setNickname": "Imposta il soprannome",
		"Email": "Posta elettronica：",
		"Email1": "Cassetta postale elettronico",
		"Email2": "Cassetta postale elettronico:",
		"editEmail": "Cambia cassetta postale elettronico",
		"setEmail1": "Cassetta postale elettronico legata",
		"Mobile": "Numero di cellulare:",
		"Mobile1": "Numero di cellulare",
		"editMobile": "Cambia numero di cellulare",
		"setMobile": "Numero di cellulare legato",
		"Avatar": "Immagine di utente",
		"basic": "Informazioni personali",
		"Save": "Salva",
		"Select_all": "Ripristina Seleziona tutto",
		"Ple_phone": "Inserisci il numero di telefono da legare",
		"code": "Codice di verifica:",
		"Ple_code": "Inserisci il codice di verifica",
		"Obtain_code": "Ottieni codice di verifica",
		'Bind_phone': 'Telefono legato',
		"After_bindingPh": "Dopo aver legato il cellulare è possibile recuperare la password tramite il cellulare",
		"Untie_phone": "Sblocca il cellulare",
		"Change_phone": "Cambia il cellulare",
		"Bind_email": "Posta elettronica legata",
		"Ple_email": "Inserisci la casella di posta da legare",
		"re_enter": "Riprendi",
		"After_bindingEm": "Dopo aver legato la cassetta postale è possibile recuperare la password tramite la casella postale",
		"Unbind_email": "Sblocca casella postale",
		"Change_email": "Cambia casella postale elettronica",
		"unbind_Ph": "Sei sicuro di sbloccare il tuo cellulare?",
		"unbinding_Ph": "Dopo l'aver sbloccato non sarà possibile utilizzare il cellulare per recuperare la password!",
		"unbind_Em": "Sei sicuro di sbloccare l'email?",
		"unbinding_Em": "Dopo l'aver sbloccato non sarà possibile utilizzare l'email per recuperare la password!",
		"mobile_code": "Il codice di verifica è stato inviato al tuo cellulare, controlla per favore",
		"email_code": "Il codice di verifica è stato inviato alla tua email, controlla per favore",
		"suc_ph": "Cellulare legato con successo",
		"suc_em": "Posta elettronica associata con successo",
		"code_frequently": "I codici di verifica vengono inviati più volte. Riprova più tardi",
		"personalCenter": "Impostazione dell'account",
		"basicInfo": "Informazioni di base",
		"accountSecurity": "Sicurezza dell'account",
		"backTo": "Indietro",
		"uploadAvatar": "Cambia foto del profilo",
		"bindPhone": "Lega cellulare",
		"bindEmail": "Lega  indirizzo di E-mail",
		"changePwdTip": "Una password con alta sicurezza può rendere l'account più sicuro. Si consiglia di cambiare la password regolarmente e impostare una password a 6 ~ 32 caratteri.",
		"bindPhoneTipBefore": "Telefono collegato:",
		"bindEmailTipBefore": "Indirizzo di E-mail legato:",
		"bindPhoneTip": "Configura un cellulare per accedere, recuperare la password e ricevere i messaggi inviati dal sistema.",
		"bindEmailTip": "Configura un'email per accedere, recuperare la password e ricevere i messaggi inviati dal sistema.",
		"bindPhoneTipAfter": "Puoi accedere, recuperare la tua password e ricevere i messaggi inviati dal sistema.",
		"changeBtn": "Modifica",
		"changePwd": "Modifica password",
		"changePwdSuc": "Ripristino della password riuscito",
		"finished": "Fatto",
		"retry": "Riprova",
		"changeRes": "Modifica risultati",
		"bindRes": "Risultato legato",
		"noHanzi": "La password non può contenere cinese",
		"Nickname_length_tip": "Lunghezza del soprannome utente da 2 a 32 bit"
	},
	"password": {
		"User_name": "Nome utente:",
		"Password": "Modifica della password",
		"Current_password": "Password vecchio",
		"New_password": "Password nuova：",
		"Config_newpassword": "Conferma nuova password",
		"PLCurrent_password": "Inserisci una password vecchio",
		"PLNew_password": "Inserisci una password nuova",
		"PLConfig_newpassword": "Conferma nuova password",
		"editPwdSuc": "Password modificata con successo",
		"loginAgain": "La password è stata modificata correttamente, per favore accedi di nuovo",
		"Save": "Salva"
	},
	"settingalarm": {
		"chosesstation": "Seleziona la centrale elettrica",
		"addEmails": "Aggiungi email",
		"delete": "E-mail eliminato con successo",
		"deletes": "Cancella",
		"Email_List": "Elenco dell' email",
		"Add_Mailbox": "Nuova aggiunta di posta elettronica spinta",
		"cancel": "Annulla",
		"Add": "Aggiungi",
		"Email_Setting": "Impostazioni e-mail",
		"Alarm_Type": "Tipo di allarme:",
		"Warning": "Allarme",
		"Error": "Errore",
		"Fault": "Ricorda",
		"Receiving_Report": "Gestione della relazione",
		"Daily_Report": "Relazione giornaliera",
		"Monthly_Report": "Relazione mensile",
		"Yearly_Report": "Relazione annuale",
		"Receiving_Plant": "Centrale elettrica spinta:",
		"E_Mail": "Posta elettronica：",
		"Email": "Posta elettronica",
		"Plant": "Centrale elettrica associato",
		"Operation": "Operazione",
		"Alarm_Typetabel": "Tipo di allarme",
		"Yes": "Sì",
		"No": "No",
		"Delete": "Cancella",
		"suredelete": "Cancella i messaggi spinti da questa posta elettronica?",
		"Delete_Mailbox": "Elimina casella di posta",
		"Add_suc": "E-mail aggiunto con successo",
		"create": "Crea",
		"list": "Numero",
		"edit": "Edita gruppi"
	},
	"recharge": {
		"cancel": "Annulla",
		"early_warning": "Allarme di scadenza della scheda flusso",
		"orderno": "Numero d'ordine",
		"Recharge_tip4": "Consigliare agli utenti che si sono registrati a PayPal di utilizzarlo",
		"recharge_type": "tipo",
		"Recharge_tip3": "Consigliato per gli utenti WeChat che lo hanno già installato",
		"Recharge1": "Ricarica del traffico",
		"rechargeStatus": "Stato di ricarica",
		"Recharge_tip5": "WeChat Pay",
		"openWx": "Apri WeChat sul tuo cellulare",
		"Hint_language": "Il tuo dispositivo ha un dispositivo 2G. Su richiesta del Ministero dell'Industria e della Tecnologia dell'Informazione, le reti 2G sono gradualmente in fase di abbandono e si consiglia di acquistare e sostituire dispositivi 4G!",
		"rechMoney": "pagamento",
		"Recharge": "Ricarica in corso",
		"Recharge_tip": "Promemoria di ricarica",
		"Dead_Time": "Tempo di scadenza",
		"domestic": "nazionale",
		"not_for_the_time_being": "Da non trattare temporaneamente",
		"Hint_language1": "Se si verificano problemi durante il processo di ricarica, si prega di contattare la hotline del servizio post-vendita al 0755-89993588",
		"rechDiscount": "Già scontato",
		"Search": "Ricerca",
		"warning": "allarme rapido",
		"Recharge_tip2": "Si prega di scegliere, ad esempio: la stessa capacità di carico è 1; Lo stesso tipo di carta è 4G; Ricarica all'ingrosso per schede dati della Cina continentale nella stessa regione",
		"Recharge_tip1": "Supporta solo la ricarica di massa di carte dello stesso tipo",
		"rechScan": "Apri WeChat sul tuo cellulare, scansiona per completare il pagamento",
		"rechTip": "Promemoria: 1. solo i dispositivi con lo stesso tipo di carta (come 4G domestico), la stessa capacità di carico e lo stesso stato della piattaforma di riduzione della povertà possono essere selezionati per lo stesso ordine (display predefinito mostra pacchetti con una capacità di carico di 1 e non connessi alla piattaforma di riduzione della povertà); 2. La ricarica delle carte scadute e la ricarica tra il 25 e il 5 di ogni mese comporterà un ritardo di 1-14 giorni.",
		"Traffic_status": "Stato del flusso",
		"Status": "Stato della scheda di flusso",
		"DataloggerPN": "PN:",
		"Recharge_money": "Importo di ricarica",
		"Overdue": "Scadenza",
		"Cancel_recharge": "Annulla ricarica",
		"Datalogger_List": "Elenco dei registratori di dati",
		"Recharged": "Ricaricato con successo",
		"Rcharge_Month": "Mesi di ricarica",
		"Service_Area": "Area di servizio",
		"Datalogger_PN": "Numero PN del registratore di dati",
		"rechargeDevice": "Apparecchiature di ricarica:",
		"rechargeSucInfo": "Hai pagato con successo. l traffico arriverà entro 24 ore",
		"Confirm_recharge": "Conferma ricarica",
		"scan": "Scansiona il pagamento",
		"Paid": "Pagato",
		"Time": "Tempo di ricarica",
		"Unpaid": "Non pagato",
		"Operation": "Operazione",
		"Connecting_Devices": "Carico",
		"Recharge_reminder": "Promemoria di ricarica",
		"scanComplete": "Scansiona per completare il pagamento",
		"unknown": "sconosciuto",
		"rechargeChannel": "Metodo di ricarica:",
		"Signal": "Valore del segnale",
		"Plant": "Nome della centrale elettronica",
		"rechargeDiscount": "Importo dello sconto:",
		"expired": "Scaduto",
		"load": "Carico",
		"Recharge_List": "Elenco di ricarica",
		"ccid": "Numero della scheda di flusso del collettore dati",
		"Order_Number": "Numero d'ordine",
		"Package_type": "Tipo di confezione",
		"Recharge_record": "Storia di ricarica",
		"DataloggerName": "Alias",
		"Recharging": "Ricaricamento in corso",
		"Recharge_Selected": "Ricarica in corso",
		"rechargeErr": "Seleziona un registratore dati con lo stesso carico",
		"rechargePrice": "Importo di ricarica:",
		"abroad": "all'estero",
		"normal": "Normale",
		"previous": "Ritorno",
		"CCID": "Numero della scheda di flusso",
		"CCID_time": "Scadenza della scheda di flusso",
		"serial_number": "Numero",
		"Activation_Time": "Tempo di attivazione",
		"confirm": "Conferma",
		"Recharge_status": "Stato di ricarica",
		"Recharge_now": "Ricarica ora",
		"Content_warning": "Gentile utente, Si è scoperto che la sua schedina dati del dispositivo sta per scadere. Se non viene ricaricata in tempo, la schedina verrà cancellata dall'operatore e non funziona più . Per non influenzare il suo utilizzo normale, si prega di ricaricare l'impianto nello stato di allerta in tempo!",
		"Recharge_fail": "Ricarica non riuscita",
		"rechargePackage": "Pacchetto di ricarica:",
		"rechargeSuc": "Pagamento riuscito",
		"pn": "Numero PN del registratore di dati",
		"Tips": "Consigli",
		"Recharge_successful": "Ricaricato con successo",
		'Recharge_tip6': "Ci sono schede che non supportano la ricarica,Si prega di contattare l'amministratore",
				'remedy_title': 'Rimedio ordine di ricarica',
				'upload_tip': 'Promemoria amichevole: Il formato del file di caricamento è .txt'
	},
	"customize": {
		"switchSkin": "Cambia pelle",
		"classic": "rosa",
		"purple": "viola",
		"blue": "Blu classico",
		"orange": "Arancia dolce",
		"green": "Verde fresco"
	},
	"firmware": {
		"Firmware_limit_format": "Sono consentiti solo i formati di file .bin, .hex e .s19",
		"Firmware_upload_fail": "Caricamento fallito, riprova!",
		"Firmware_upload_failTip": "Caricamento fallito",
		"Firmware_limit1": "Puoi caricare un massimo di",
		"Firmware_limit2": "file",
		"Firmware_limit3": "firmware",
		"Firmware_limitM": "La dimensione del singolo file firmware non può superare", 
		"Firmware_Name": "Nome del firmware",
		"Firmware_desrc": "Descrizione del firmware",
		"Size": "Dimensione del firmware (KB)",
		"Upload_Time": "Tempo di caricamento",
		"Operation": "Operazione",
		"Firmware_List": "Gestione del firmware",
		"Firmware_Lists": "Elenco firmware",
		"Add_Firmware": "Aggiungi firmware",
		"deleteFirmware": "Cancella",
		'Firmware_Version': 'Numero di versione',
		'editFirmware': 'Modifica',
		'downloadFirmware': 'Download',
		"tips": "Consigli",
		"noRecord": "Nessuna registrazione",
		"delete_firmware": "Sei sicuro di eliminare questo firmware?",
		"del_firmware": "Rimuovi firmware",
		"firmware_upgrade": "Aggiorna firmware",
		"uploadTips": "Carica il file del firmware",
		"cancel": "Annulla",
		"confirm": "Conferma",
		"Upload_firmware": "Carica",
		"Firmware_description": "Descrizione del firmware:",
		"enter_content": "Inserisci il contenuto",
		"Select_file": "Seleziona i file",
		"limit": "Solo i file nei formati \".bin\" e \".hex\" possono essere caricati e le dimensioni non superano 8M",
		"limit0": "Solo i file nei formati \".bin\" e \".hex\" e \".s19\" possono essere caricati e le dimensioni non superano 8M",
		"limit1": "Solo i file nel formato \"xlsx\" possono essere caricati",
		"limit2": "Promemoria amichevole: la colonna A del file caricato è il PN registratore di dati, e la colonna B è l'alias registratore di dati. Non è neccessario avere un titolo. Si vede la figura seguente.",
		'limit3': 'Aggiunta con successo',
		"error1": "Possono essere caricati solo i file nei formati \".bin\" e \".hex\",\".s19\"",
        "error2": " Please press LFU button",
		"deleteSuc": "Rimosso con successo",
		"UploadTitle": "Carica file dei lotti",
		"Upload": "Carica",
		"Upload1": "Carica file",
		"upgrade_quit1": "Eccezione dell'aggiornamento, uscito!",
		"upgrade_quit2": "Aggiornamento fallito. Riprova più tardi!",
		"upgrade_quit3": "Aggiornato con successo",
		"upgrade_quit4": "L'aggiornamento è stato annullato manualmente",
		"upgrade_quit5": "Non aggiornato",
		"upgrade_quit6": "Aggiornamento annullato",
		"upgrade_quit7": "Aggiornamento fallito",
		"upgrade_quit8": "Eccezione di aggiornamento",
		"upgrading": "Aggiornamento",
		"upgrading1": "Aggiornamento della connessione, attendere",
		"updateCompleted": "Aggiornamento completato",
		"CancelUpgradeSuc": "Aggiornamento annullato con successo",
		"FailedCancelUpgrade": "Annullamento di aggiornamento non riuscito",
		"CancelUpgradeSuc11": "Annulla l'aggiornamento con successo, aspetta che il datalogger si connetta al cloud prima dell'aggiornamento",
		"upgrade_wait": "Preparazione dell’aggiornamento in corso, attendere 1–2 minuti",
		"upgrade_wait1": "Preparazione dell’aggiornamento completata. Attendere che il datalogger sia online, quindi riavviare il compito di aggiornamento",
		"colOffline": "Il datalogger non è in linea",
		"colUpgrading": "Aggiornamento già in corso",
		"UpgradeStarting": "Aggiornamento in corso, attendere...",
		"upgradeSq_fail": "Aggiornamento del datalogger fallito, riprova più tardi!",
	},
	"browse": {
		'usr': 'Sottoconto',
		'email': 'cassetta postale',
		'mobile': 'telefono cellulare',
		'gts': 'Data di registrazione',
		'desc': 'Osservazioni',
		'enableStatus': 'Abilita stato',
		'Enable': 'Abilita',
		'Disable': 'Disabili',
		'addBrowse': 'Aggiungi sotto account',
		'pleaseUsr': 'Inserisci un sub account',
		'accountInfo': "informazioni sull'account",
		'username': 'nome utente',
		'password': 'password',
		'newPassword': 'Nuova password',
		'confirmPassword': 'Conferma password',
		'usrInfo': 'Informazioni utente',
		'device': 'Selezione progetto',
		'pleaseDevice': 'Seleziona progetto',
		'pleaseDevice_title': 'Seleziona un progetto',
		'pleaseStatus': 'Seleziona stato',
		'addSuccess': 'Sottoconto aggiunto con successo',
		'editSuccess': 'Sottoconto modificato correttamente',
		'editBrowse': 'Modifica sotto account',
		'deleteSuccess': 'Eliminato con successo',
		'deleteBrowse': 'elimina',
		'delete_browse': 'Sei sicuro di eliminare il sub account?',
		'please_browsepwd': 'Si prega di controllare la nuova password e confermare i requisiti di immissione della password',
	},
	"retrieve": {
		"Retrieve_password": "Recupera password",
		"Retrieve_passwordPhone": "Recupero password via il cellulare",
		"Retrieve_passwordEmail": "Recupero password via e-mail",
		"passwordEmail": "Casella postale elettronica non legata",
		"passwordEmail1": "La casella di posta elettronica non va",
		"passwordPhone": "Numero di cellulare non legato",
		"passwordPhone1": "Numero di cellulare non va",
		"login": "Accedi",
		"signup": "Iscriviti",
		"Enter_account": "Inserisci l'account",
		"Verify_identidy": "Verifica identità",
		"reset_Password": "Reimposta password",
		"finish": "Fatto",
		"account_password": "Inserisci l'account a quello che vuoi recuperare la sua password",
		"username": "Nome utente",
		"Verification_code": "Codice di verifica",
		"phone_number": "Cellulare",
		"new_password": "Nuova password",
		"Con_password": "Conferma password",
		"enter_name": "Inserisca il nome utente per favore",
		"enter_code": "Inserisci il codice di verifica",
		"Change_one": "Cambia un altro",
		"confirm": "Conferma",
		"bound_mobile": "Inserisci il cellulare collegato",
		"Email_verification": "Verifica e-mail",
		"Obtain_code": "Ottieni codice di verifica",
		"code_1minute": "Il codice di verifica è stato inviato al tuo cellulare. E' valido inserire entro 1 minuto.",
		"Email": "Posta elettronica",
		"bound_email": "Inserisci l' e-mail associata",
		"Phone_verification": "Verifica telefonica",
		"code_5minutes": "Il codice di verifica è stato inviato alla tua email. E' valido inserire entro 5 minuto.",
		"New_password": "Nuova password",
		"Confirm_password": "Conferma password",
		"Reset_successfully": "Ripristino riuscito, ricorda la tua password",
		"re-register": "Accedi di nuovo",
		"Incorrect_code": "Codice di verifica sbagliato",
		"email_first": "Si prega di compilare prima l'email",
		"mobile_first": "Inserisci prima il numero di cellulare",
		"Reset_passwordSuc": "Ripristino della password riuscito",
		"Get_codeSucc": "Il codice di verifica ottenuto con successo",
		"Getting_progress": "Ricevuto in corso, attendi per favore!",
		"Newloginpassword": "Nuova password di accesso",
		"Confirmloginpassword": "Conferma la nuova password di accesso",
		"step1": "Fase 1",
		"step2": "Fase 2",
		"step3": "Fase 3",
		"step4": "Fase 4"
	},
	"errCode": {
		"0": "Normale, nessun errore",
		"1": "Fallito",
		"2": "Ore straordinarie",
		"3": "Il sistema e' anormale. Si prega di contattare l'amministratore",
		"4": "Una firma non verificabile",
		"5": "Il valore del sale è sbagliato. Non è usato dalle regole",
		"6": "Errore di formato dei parametri",
		"7": "Parametri richiesti mancanti",
		"8": "Rifiuto della piattaforma",
		"9": "Operazione non supportata",
		"10": "Autenticazione non riuscita, accedi di nuovo",
		"11": "Operazione senza autorizzazione",
		"12": "Nessuna registrazione",
		"13": "Limite superato",
		"14": "Ripeti operazione",
		"15": "La chiavetta del produttore non trovata",
		"16": "Errore della password",
		"17": "Formato della password sbagliato",
		"18": "Il numero di cellulare è stato collegato. Cambia il numero o sblocca",
		"19": "Errore di formato del numero di cellulare (6<=lunghezza<32)",
		"20": "Errore di formato posta elettronica (6<=lunghezza<64 e contiene @ )",
		"21": "Errore di formato del nome utente (2<=lunghezza<32)",
		"22": "Errore di formato del nome della società",
		"23": "Il codice del produttore non è valido. Verifica se sia compilato correttamente",
		"24": "Ripetizione del nome utente",
		"25": "L'account è stato disabilitato, si prega di contattare l'amministratore",
		"26": "L'email è stata vincolata. Per favore modifica l'email o annullala",
		"27": "L'account è stato cancellato, si prega di contattare l'amministratore",
		"256": "Nessun dato",
		"257": "Nessun registratore di dati",
		"258": "Nessun dispositivo",
		"259": "Numero PN non valido, verificare se il numero PN è corretto",
		"260": "Nessuna centrale elettrica",
		"261": "Utente non trovato",
		"262": "Il dispositivo non è in rete",
		"263": "Il registratore di dati non è in rete",
		"264": "Nessun allarme del dispositivo",
		"265": "Nessun rilevatore ambientale",
		"271": "Nessun operazione di modifica",
		"272": "Legato ripettutamente",
		"273": "Aggiungere i registratori dati fatti da altri produttori non è supportato.",
		"276": "Non supporta i proprietari di centrale elettriche che dispongono dei registratori dati contenenti altri produttori",
		"288": "Nessuna telecamera",
		"352": "Nessun firmware",
		"353": "Nessun accordo",
		"368": "Nessun ruolo",
		"369": "Nessun raggruppamento utente",
		"370": "Nessun raggruppamento di centrale elettrica",
		"371": "Nessun pacchetto di ricarica del traffico GPRS",
		"372": "Nessun ordine di ricarica del traffico GPRS",
		"384": "Errore di codice di verifica inserito",
		"385": "Nessun device-token",
		"386": "Nessuna informazione sulla configurazione del dispositivo",
		"387": "Nessun tipo di registratore dati",
		"512": "Il codice di verifica SMS non corrisponde",
		"513": "Il codice di verifica SMS è scaduto",
		"514": "Numero di cellulare/E-mail non asscociato",
		"515": "Numero di cellulare/E-mail non corrisponde",
		"516": "Non è possibile avere lo stesso nome",
		"517": "Ci sono anche registratori di dati sotto l'utente o la centrale elettrica",
		"518": "L'utente ha anche utenti subordinati",
		"519": "Ripetizione del nome utente",
		"520": "Ripetizione numero di PN",
		"521": "Il  registratore di dati non appartiene a questo utente",
		"522": "Il registratore di dati esiste già",
		"523": "Non è un account visualizzatore",
		"525": "Il codice di verifica è stato inviato. Riprova più tardi",
		"528": "Questo ruolo è già legato a un utente e non può essere eliminato",
		"768": "Nell'accordo non ci sono campi opzionali",
		"772": "Il registratore dei dati è stato legato",
		"1024": "Solo il proprietario della centrale elettrica è supportato",
		"1025": "Sono supportati solo gli amministratori",
		"1026": "Sono supportati solo i produttori dei dispositivi",
		"1027": "L'utente superiore deve essere un amministratore o un produttore del dispositivo",
		"1028": "Metodo di ricarica non supportato",
		"1029": "Numero del registratore dei dati ripettuato",
		"1030": "Scheda GPRS non valida",
		"1031": "L'utente non è stato creato da questo amministratore",
		"1041": "La chiave è scaduta o non può essere trovata",
		"1042": "CCID non valido",
		"1792": "Tutti i  registratori dei dati devono appartenere a questo amministratore"
	},
	"controlDeviceErrCode": {
		"1": "Operazione fallita. Controlla il dispositivo e riprova!",
		"2": "Tempo di risposta scaduto, riprova!",
		"3": "Il sistema e' anormale. Si prega di contattare l'amministratore",
		"6": "Errore di formato, si prega di contattare l'amministratore",
		"8": "Rifiutato, si prega di contattare l'amministratore",
		"9": "Operazione non supportata, si prega di contattare l'amministratore",
		"11": "Nessun autorizzazione, contatta l'amministratore",
		"263": "Il registratore dati non è in rete. Riprova dopo che è in rete!"
	},
	"control":{
		"setting": "Invio",
		"TouSetting": "Modalità di Lavoro del Sistema",
		"touCharge": "Priorità di Carica",
		"touPersonal": "Autoconsumo",
		"touComplete": "Immissione Totale in Rete",
		"touClipping": "Taglio dei Picchi e Riempimento delle Valli",
		"touOffgrid": "Applicazione Off-Grid",
		"confirmModeSwitch": "Confermare il Cambio Modalità?",
		"modeSwitch": "Cambia Modalità",
		"startTime": "Ora di Inizio",
		"endTime": "Ora di Fine",
		"paramValue": "Seleziona Valore Parametro",
		"Monday": "Lunedì",
		"Tuesday": "Martedì",
		"Wednesday": "Mercoledì",
		"Thursday": "Giovedì",
		"Friday": "Venerdì",
		"Saturday": "Sabato",
		"Sunday": "Domenica",
		"syncSetDay": "Invio Sincronizzato Giornaliero",
		"time": "Periodo Temporale 1",
		"time1": "Periodo Temporale 2",
		"time2": "Periodo Temporale 3",
		"time3": "Periodo Temporale 4",
		"time4": "Periodo Temporale 5",
		"time5": "Periodo Temporale 6",
		"setFail": "Invio Fallito",
		"readFail": "Lettura Fallita",
		"charge": "Carica",
		"discharge": "Scarica",
		"reading": "Lettura Riuscita",
		"reading_loading": "Lettura in Corso...",
		"pvMode": "Modalità Immissione in Rete",
		"screenshot": "Screenshot"
	},
	"CollectorCountByOMSOrder": {
		"1": "Operazione fallita",
		"7": "Mancano parametri necessari",
		"8": "Respinto, contattare l'amministratore",
		"12": "Non c'è un numero PN valido del collettore sotto l'ordine, si prega di confermare il numero d'ordine",
		"23": "Il codice del produttore non è valido. Si prega di contattare l'amministratore",
		"259": "Ci sono collezionisti non validi sotto questo ordine. Si prega di contattare l'amministratore",
		"261": "Impossibile trovare il distributore assegnato, contattare l'amministratore",
		"772": "L'ordine ha già un collettore vincolato. Si prega di confermare che il collettore nell'ordine non è vincolato",
	},
	"message": {
		"uname_is_required": "L'account non può essere vuoto",
		"id_is_required": "Il gruppo non può essere vuoto",
		"pwd_is_required": "La password non può essere vuota",
		'confpwd_is_required': 'Conferma la password non può essere vuota',
		"invitation_is_required": "Il codice esperienza non può essere vuoto",
		"pwdAgain": "Conferma la password",
		"pwdSame": "Le password nuove e vecchie non possono essere uguali",
		"oldPass_wrong": "La vecchia password non è corretta. Inserisci di nuovo.",
		"pwdNotsame": "Le password che sono inserite due volte non corrispondono",
		"email_is_required": "Indirizzo di E-mail non può essere vuoto",
		"email_info": "Indirizzo di E-mail corretto entro 64 caratteri",
		"mobile_is_required": "Il numero di cellulare non può essere vuoto",
		"pn_is_required": "PN non può essere vuoto",
		"PN_info": "La lunghezza del numero PN è di 14 o 18 cifre, con la prima lettera maiuscola e contenente solo l'inglese maiuscolo e i numeri",
		"nodata": "Nessun dato",
		"length2_64": "Lunghezza compresa tra 2 e 64 caratteri",
		"length2_32": "Lunghezza compresa tra 2 e 32 caratteri",
		"length6_20": "È possibile inserire solo 6-20 lettere, numeri e sottolineature",
		"length6_32": "Lunghezza compresa tra 6 e 32 caratteri",
		"delete_plant": "Elimina centrale elettrica",
		"modify_plant": "Modifica la centrale elettrica",
		"Exporting_the_report": "Questo account è in stato di cancellazione, non può accedere",
		"cancel": "Annulla",
		"search": "Ricerca",
		"Logging_off": "Questo account è in fase di disconnessione e non può essere effettuato l'accesso",
		"country_is_required": "Seleziona un paese o una regione",
	},
	"report": {
		"Export_report": "Esporta relazione",
		"Subscribe_report": "Iscriviti a un report",
		"all_reports": "Esporta tutto",
		"Report_type": "Tipo di relazione",
		"Daily_report": "Relazione giornaliera",
		"Monthly_report": "Relazione mensile",
		"Yearly_Report": "Relazione annuale",
		"Total_report": "Totale delle relazioni",
		"customize": "Personalizzato",
		"Report_date": "Data di relazione:",
		"Report_date1": "Nota: L'intervallo di date di esportazione non può superare i 31 giorni",
		"select_date": "Seleziona una data",
		"to": "a",
		"start_date": "Data iniziale",
		"End_date": "Data finale",
		"cancel": "Annulla",
		"Export": "Esporta",
		"download": "Scaricamento in corso, attendi per favore.",
		"Batch_export": "Esportazione di lotti",
		"current": "Questo momento",
		"no_deAlarm": "Nessun allarme del dispositivo è successo nell'ultimo mese",
		"Export_alarm": "Esporta allarme"
	},
	"collectionFrequencyUP": {
		"collect_fast": "Accelerazione della raccolta del flusso energetico",
		"collect_fast2": "Accelerazione del flusso energetico",
		"collect_fast_fail": "Accelerazione non riuscita, riprova",
		"collect_fasting": "Accelerare",
		"collect_fast_starting": "Avvio dell'accelerazione",
		"collect_fast1": "Accelerazione della raccolta di dati dettagliati",
		"collect_fast1ing": "Accelerazione dei dati",
		"paySecCon": "Conferma del pagamento",
		"energyFetchPic": "Se confermare la ricarica, la gamma di accelerazione della ricarica per i parametri della pagina del flowchart di energia come mostrato sotto",
		"historyFetchPic": "Se confermare la ricarica, la gamma di accelerazione della ricarica per i parametri della pagina dettagliata dei dati come mostrato sotto",
		"reRechargeTip1": "Il dispositivo attuale ha già acquistato il servizio di accelerazione del flusso di energia. Continuando l'acquisto verranno addebitati nuovamente dei costi. Vuoi continuare?",
		"reRechargeTip": "Il dispositivo attuale ha già acquistato il servizio di accelerazione dei dettagli dati. Continuando l'acquisto verranno addebitati nuovamente dei costi. Vuoi continuare?",
		"continueRecharge": "Continua ricarica",
		"collect_fasting_title": "I parametri in tempo reale non vengono memorizzati",
		"collect_Order_Record": "Registrazione accelerata",
		"Collection_terms": "Termini di ricarica dell'accelerazione della frequenza di raccolta",
		"Recharge_failed_next": "Spiacenti per la ricarica non riuscita, puoi provare a pagare di nuovo",
		"view_order": "Visualizza ordini",
		"Once": "secondo",
		"every_interval": "La specifica di accelerazione attualmente selezionata è: ogni intervallo",
		"Collect_terms2": "1,Campo di applicazione del pacchetto",
		"Collect_terms3": "I parametri di visualizzazione inclusi nel protocollo utilizzato dal collettore per la ricarica (nota: se si seleziona la pagina Energy Flow Graph per la ricarica accelerata, l'ambito del pacchetto è limitato all'intervallo dei parametri visualizzati nella pagina Energy Flow Graph; se si seleziona la pagina Dati storici per la ricarica accelerata, l'ambito del pacchetto è limitato all'intervallo dei parametri visualizzati nella pagina Dati storici)",
		"Collect_terms4": "2,Non supporta protocollo / dispositivo di sostituzione",
		"have_read": "L'ho letto a fondo",
		"Collect_terms5": "Cambiare protocolli/dispositivi non partecipa al godimento dell'accelerazione",
		"Collect_terms6": "3,Annulla il pacchetto",
		"Collect_terms": "Raccogliere termini di ricarica accelerata",
		"View_Details": "Visualizza dettagli",
		"Recharge_result": "Risultato della ricarica",
		"Collect_terms7": "Cancellazione e modifica non supportati dopo il pagamento",
		"Online_payment": "Pagamento online",
		"Collect_terms8": "4,Prezzo del pacchetto",
		"Collect_terms9": "Le nostre tariffe sono calcolate in base alla quantità dei parametri, alla frequenza accelerata di raccolta e alla capacità di carico e il prezzo finale è determinato di conseguenza; Oltre alle condizioni di cui sopra, i dati storici comportano anche il tempo di conservazione",
		"acquisition_frequency": "Frequenza di raccolta",
		"Recharge_failed": "Ricarica non riuscita",
		"Recharge_amount": "Importo di ricarica",
		"Scan_payment": "Pagamento del codice di scansione",
		"collect_recharge": "Ricarica dell'accelerazione della raccolta (accelerazione della raccolta dettagliata)",
		"collect_recharge1": "Ricarica dell'accelerazione della raccolta (accelerazione del flusso energetico)",
		"Collect_terms10": "5,Consumo di traffico",
		"Purchase_Terms7": "Ci sono altre domande",
		"Purchase_Terms8": "Se hai altre domande, puoi contattare il nostro servizio clienti online per la consultazione, e ti forniremo risposte dettagliate",
		"Collect_terms11": "Accelerare la frequenza di raccolta esacerbare il consumo di traffico",
		"Purchase_Terms6": "Le nostre tariffe sono calcolate in base alla quantità dei parametri, alla frequenza accelerata di raccolta e alla capacità di carico e il prezzo finale è determinato di conseguenza; Oltre alle condizioni di cui sopra, i dati storici comportano anche il tempo di conservazione",
		"Purchase_Terms5": "Prezzo del pacchetto",
		"Purchase_Terms4": "Attendi con ansia la nostra nuova versione. La versione corrente supporta solo la raccolta e l'aggiornamento di tutti i parametri di visualizzazione. Ci scusiamo per eventuali inconvenienti causati!",
		"Purchase_Terms3": "Non posso personalizzare l'aggiornamento della frequenza di raccolta per alcuni parametri",
		"Real_parameters": "Parametri in tempo reale",
		"Purchase_Terms1": "Periodo di validità dell'accelerazione della raccolta",
		"Purchase_Terms2": "La data di scadenza del servizio di accelerazione della raccolta verrà calcolata automaticamente in base alla durata del pacchetto acquistato. La data di scadenza specifica è soggetta alla visualizzazione della pagina",
		"device_Info": "Informazioni",
		"Recharge_successful_next": "Congratulazioni per il successo della ricarica. Stiamo per aggiornare la frequenza di raccolta e da ora in poi potrai seguire i cambiamenti della frequenza di raccolta.",
		"Purchase_Terms": "Condizioni di acquisto",
		"gather": "raccolta",
		"Recharge_time": "Tempo di ricarica",
		"Payment_method": "Metodo di pagamento",
		"Type": "Tipo di ricarica",
		"Recharge_now": "Ricarica ora",
		"History_Data": "dati storici",
		"Collect_terms1": "Condizioni del servizio di accelerazione del servizio di frequenza di raccolta",
		"Package": "Pacchetto di accelerazione",
		"PN_order": "PN/Numero d'ordine",
		"Order_No": "Numero d'ordine",
		"Recharge_successful": "Ricaricato con successo",
		"noRecharg": "Il collettore non supporta la ricarica",
		"noRecharg_min": "La tua velocità di raccolta ha raggiunto il suo più veloce!",
		"noRecharg_wifi": "La versione corrente supporta solo l'acquisizione dati del modulo Wi-Fi",
		"paypalTip": "L'importo del pagamento finale è basato su PayPal",
		"upPrice": "Differenza di prezzo",
	},
	alarmNew: {
		'fileName': 'Nome del file',
		'fileSize': 'Dimensione del file',
		'fileStatus': 'Stato del file',
		'progress': 'Progresso',
		'can': 'Scaricabile',
		'no': 'In esportazione',
		'history': 'Cronologia esportazioni'
	},
		shuoriExport:{
       "exportRecords": "Record di esportazione",
       "export": "Esporta",
       "exportTask": "L'attività di esportazione è stata creata. Scaricala successivamente nei Record di esportazione.",
       "noDownload": "L'indirizzo del file non è valido o non è possibile scaricarlo. Riprova.",
	   'data': 'Data',
	},
		colUnBindRecord: {
	'UnBindRecord': 'Registro di sblocco del raccoglitore dati',
    "unStatus": "Stato di Scollegamento",
    "unScene": "Scenario di Scollegamento",
    "oldUser": "Utente Originale",
    "newUser": "Nuovo Utente",
    "unCount": "Numero di Scollegamenti",
    "pnBarCode": "Codice a barre PN",
    "devicePicture": "Foto del dispositivo reale",
    "ip": "IP Scollegato",
    "unTime": "Ora di Scollegamento"
	},
		rosRecharge: {
		'electronicInvoicing': 'Fatturazione Elettronica',
		'issueEInvoice': 'Emetti Fattura Elettronica',
		'invoiceHistory': 'Storico Fatture',
		'rechargeDuration': 'Durata Ricarica',
		'year': 'Anno',
		'month': 'Mese',
		'day': 'Giorno',
		'days': 'Giorni',
		'pendingPayment': 'In Attesa di Pagamento',
		'paymentSuccess': 'Pagamento Riuscito',
		'paymentFailed': 'Pagamento Fallito',
		'orderClosed': 'Ordine Chiuso',
		'serviceTerminated': 'Servizio Terminato',
		'unpaid': 'Non Pagato',
		'paying': 'In Pagamento',
		'paid': 'Pagato',
		'refunded': 'Rimborsato',
		'cancelled': 'Annullato',
		'rechargeSuccess': 'Ricarica Riuscita',
		'rechargeFailed': 'Ricarica Fallita',
		'pleaseSelectDate': 'Seleziona Data',
		'orderNo': 'Numero Ordine',
		'batchInvoicing': 'Fatturazione in Batch',
		'rechargeType': 'Tipo di Ricarica',
		'trafficRecharge': 'Ricarica Traffico',
		'collectRecharge': 'Ricarica Raccolta',
		'rechargeStatus': 'Stato Ricarica',
		'invoice': 'Fattura',
		'invoiceStatus': 'Stato Fattura',
		'invoiceTime': 'Ora Fatturazione',
		'viewDetail': 'Visualizza Dettagli',
		'invoicing': 'In Fatturazione',
		'invoiceSuccess': 'Fattura Emessa',
		'invoiceFailed': 'Emissione Fattura Fallita',
		'issueElectronicInvoice': 'Emetti Fattura Elettronica',
		'invoiceType': 'Tipo Fattura',
		'generalInvoice': 'Fattura Ordinaria',
		'specialInvoice': 'Fattura Speciale',
		'headerType': 'Tipo Intestazione',
		'companyHeader': 'Intestazione Aziendale',
		'personalHeader': 'Intestazione Personale/Non Aziendale',
		'pleaseInputCompanyHeader': 'Inserisci Intestazione Aziendale',
		'taxNumber': 'Partita IVA',
		'pleaseInputTaxNumber': 'Inserisci il Codice Fiscale del Contribuente',
		'headerName': 'Nome Intestazione',
		'suggestPersonalName': 'Si Consiglia di Inserire Nome Personale/Nome Negozio',
		'invoiceContent': 'Contenuto Fattura',
		'internetCommService': 'Servizio di Comunicazione Internet',
		'invoiceAmount': 'Importo Fattura',
		'yuan': 'Yuan',
		'moreInfo': 'Ulteriori Informazioni',
		'remarkAddressEtc': 'Note, Indirizzo, ecc.',
		'companyAddress': 'Indirizzo Aziendale',
		'pleaseInputCompanyAddress': 'Inserisci Indirizzo Aziendale',
		'companyPhone': 'Telefono Aziendale',
		'pleaseInputCompanyPhone': 'Inserisci Telefono Aziendale',
		'openingBank': 'Banca di Apertura Conto',
		'pleaseInputOpeningBank': 'Inserisci Banca di Apertura Conto',
		'bankAccount': 'Numero di Conto Bancario',
		'pleaseInputBankAccount': 'Inserisci Numero di Conto Bancario',
		'remark': 'Note',
		'pleaseInputRemark': 'Inserisci Note',
		'email': 'E-mail',
		'pleaseInputEmail': 'Inserisci Indirizzo E-mail',
		'cancel': 'Annulla',
		'submit': 'Invia',
		'invoiceResult': 'Risultato Fatturazione',
		'invoiceSubmitted': 'Richiesta di Fatturazione Inviata',
		'invoiceExpectedTip': 'La fattura verrà emessa entro 48 ore, si prega di controllare',
		'viewInvoiceStatus': 'Visualizza Stato Fattura',
		'pleaseInputHeaderName': 'Inserisci Nome Intestazione',
		'pleaseInputValidEmail': 'Inserisci un Indirizzo E-mail Valido',
		'invoiceApplyFailed': 'Richiesta di Fatturazione Fallita',
		'viewInvoice': 'Visualizza Fattura',
		'downloadPdf': 'Scarica File PDF',
		'manualService': 'Assistenza Clienti',
		'invoiceSentToEmail': 'Le informazioni della fattura sono state inviate all\'e-mail, si prega di controllare',
		'pleaseWaitInvoicing': 'Attendere il Completamento della Fatturazione',
		'pleaseContactManual': 'Contattare l\'Assistenza per la Fatturazione',
		'noPdfAvailable': 'Nessun File PDF Disponibile per il Download',
		'serviceUnavailable': 'Funzione di Assistenza Clienti Non Disponibile',

	}
}
export default it;